/**
 * Generated by @openapi-codegen
 *
 * @version 1.0
 */
import * as reactQuery from '@tanstack/react-query';
import {
    useConnectorNextContext,
    ConnectorNextContext,
} from './connector-next-context';
import type * as Fetcher from './connector-next-fetcher';
import { connectorNextFetch } from './connector-next-fetcher';
import type * as Schemas from './connector-next-schemas';

export type AccessPermissionCatalogueError = Fetcher.ErrorWrapper<undefined>;

export type AccessPermissionCatalogueResponse = Schemas.PermissionSummary[];

export type AccessPermissionCatalogueVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchAccessPermissionCatalogue = (
    variables: AccessPermissionCatalogueVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        AccessPermissionCatalogueResponse,
        AccessPermissionCatalogueError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/access/permissions', method: 'get', ...variables, signal });

export const useAccessPermissionCatalogue = <
    TData = AccessPermissionCatalogueResponse,
>(
    variables: AccessPermissionCatalogueVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            AccessPermissionCatalogueResponse,
            AccessPermissionCatalogueError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        AccessPermissionCatalogueResponse,
        AccessPermissionCatalogueError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/access/permissions',
            operationId: 'accessPermissionCatalogue',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchAccessPermissionCatalogue(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type AccessUsersError = Fetcher.ErrorWrapper<undefined>;

export type AccessUsersResponse = Schemas.UserAccess[];

export type AccessUsersVariables = ConnectorNextContext['fetcherOptions'];

export const fetchAccessUsers = (
    variables: AccessUsersVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        AccessUsersResponse,
        AccessUsersError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/access/users', method: 'get', ...variables, signal });

export const useAccessUsers = <TData = AccessUsersResponse>(
    variables: AccessUsersVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            AccessUsersResponse,
            AccessUsersError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<AccessUsersResponse, AccessUsersError, TData>({
        queryKey: queryKeyFn({
            path: '/api/access/users',
            operationId: 'accessUsers',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchAccessUsers({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type AccessAddUserError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.ProblemDetails;
}>;

export type AccessAddUserVariables = {
    body?: Schemas.AddUserRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessAddUser = (
    variables: AccessAddUserVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.UserAccess,
        AccessAddUserError,
        Schemas.AddUserRequest,
        {},
        {},
        {}
    >({ url: '/api/access/users', method: 'post', ...variables, signal });

export const useAccessAddUser = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.UserAccess,
            AccessAddUserError,
            AccessAddUserVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.UserAccess,
        AccessAddUserError,
        AccessAddUserVariables
    >({
        mutationFn: (variables: AccessAddUserVariables) =>
            fetchAccessAddUser({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessSetUserEnabledPathParams = {
    /**
     * @format uuid
     */
    userId: string;
};

export type AccessSetUserEnabledError = Fetcher.ErrorWrapper<undefined>;

export type AccessSetUserEnabledVariables = {
    body?: Schemas.SetEnabledRequest;
    pathParams: AccessSetUserEnabledPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessSetUserEnabled = (
    variables: AccessSetUserEnabledVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.UserAccess,
        AccessSetUserEnabledError,
        Schemas.SetEnabledRequest,
        {},
        {},
        AccessSetUserEnabledPathParams
    >({
        url: '/api/access/users/{userId}',
        method: 'patch',
        ...variables,
        signal,
    });

export const useAccessSetUserEnabled = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.UserAccess,
            AccessSetUserEnabledError,
            AccessSetUserEnabledVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.UserAccess,
        AccessSetUserEnabledError,
        AccessSetUserEnabledVariables
    >({
        mutationFn: (variables: AccessSetUserEnabledVariables) =>
            fetchAccessSetUserEnabled({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessRemoveUserPathParams = {
    /**
     * @format uuid
     */
    userId: string;
};

export type AccessRemoveUserError = Fetcher.ErrorWrapper<undefined>;

export type AccessRemoveUserVariables = {
    pathParams: AccessRemoveUserPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessRemoveUser = (
    variables: AccessRemoveUserVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        AccessRemoveUserError,
        undefined,
        {},
        {},
        AccessRemoveUserPathParams
    >({
        url: '/api/access/users/{userId}',
        method: 'delete',
        ...variables,
        signal,
    });

export const useAccessRemoveUser = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            AccessRemoveUserError,
            AccessRemoveUserVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        AccessRemoveUserError,
        AccessRemoveUserVariables
    >({
        mutationFn: (variables: AccessRemoveUserVariables) =>
            fetchAccessRemoveUser({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessSetLocalPasswordPathParams = {
    /**
     * @format uuid
     */
    userId: string;
};

export type AccessSetLocalPasswordError = Fetcher.ErrorWrapper<{
    status: 409;
    payload: Schemas.ProblemDetails & {
        /**
         * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
         */
        currentVersion?: string | null;
    };
}>;

export type AccessSetLocalPasswordVariables = {
    body?: Schemas.SetLocalPasswordRequest;
    pathParams: AccessSetLocalPasswordPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessSetLocalPassword = (
    variables: AccessSetLocalPasswordVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        AccessSetLocalPasswordError,
        Schemas.SetLocalPasswordRequest,
        {},
        {},
        AccessSetLocalPasswordPathParams
    >({
        url: '/api/access/users/{userId}/password',
        method: 'put',
        ...variables,
        signal,
    });

export const useAccessSetLocalPassword = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            AccessSetLocalPasswordError,
            AccessSetLocalPasswordVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        AccessSetLocalPasswordError,
        AccessSetLocalPasswordVariables
    >({
        mutationFn: (variables: AccessSetLocalPasswordVariables) =>
            fetchAccessSetLocalPassword({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessRemoveLocalPasswordPathParams = {
    /**
     * @format uuid
     */
    userId: string;
};

export type AccessRemoveLocalPasswordError = Fetcher.ErrorWrapper<undefined>;

export type AccessRemoveLocalPasswordVariables = {
    pathParams: AccessRemoveLocalPasswordPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessRemoveLocalPassword = (
    variables: AccessRemoveLocalPasswordVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        AccessRemoveLocalPasswordError,
        undefined,
        {},
        {},
        AccessRemoveLocalPasswordPathParams
    >({
        url: '/api/access/users/{userId}/password',
        method: 'delete',
        ...variables,
        signal,
    });

export const useAccessRemoveLocalPassword = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            AccessRemoveLocalPasswordError,
            AccessRemoveLocalPasswordVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        AccessRemoveLocalPasswordError,
        AccessRemoveLocalPasswordVariables
    >({
        mutationFn: (variables: AccessRemoveLocalPasswordVariables) =>
            fetchAccessRemoveLocalPassword({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessGroupsError = Fetcher.ErrorWrapper<undefined>;

export type AccessGroupsResponse = Schemas.GroupAccess[];

export type AccessGroupsVariables = ConnectorNextContext['fetcherOptions'];

export const fetchAccessGroups = (
    variables: AccessGroupsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        AccessGroupsResponse,
        AccessGroupsError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/access/groups', method: 'get', ...variables, signal });

export const useAccessGroups = <TData = AccessGroupsResponse>(
    variables: AccessGroupsVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            AccessGroupsResponse,
            AccessGroupsError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<AccessGroupsResponse, AccessGroupsError, TData>({
        queryKey: queryKeyFn({
            path: '/api/access/groups',
            operationId: 'accessGroups',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchAccessGroups({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type AccessAddGroupError = Fetcher.ErrorWrapper<undefined>;

export type AccessAddGroupVariables = {
    body?: Schemas.SaveGroupRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessAddGroup = (
    variables: AccessAddGroupVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.GroupAccess,
        AccessAddGroupError,
        Schemas.SaveGroupRequest,
        {},
        {},
        {}
    >({ url: '/api/access/groups', method: 'post', ...variables, signal });

export const useAccessAddGroup = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.GroupAccess,
            AccessAddGroupError,
            AccessAddGroupVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.GroupAccess,
        AccessAddGroupError,
        AccessAddGroupVariables
    >({
        mutationFn: (variables: AccessAddGroupVariables) =>
            fetchAccessAddGroup({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessUpdateGroupPathParams = {
    /**
     * @format uuid
     */
    groupId: string;
};

export type AccessUpdateGroupError = Fetcher.ErrorWrapper<undefined>;

export type AccessUpdateGroupVariables = {
    body?: Schemas.SaveGroupRequest;
    pathParams: AccessUpdateGroupPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessUpdateGroup = (
    variables: AccessUpdateGroupVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.GroupAccess,
        AccessUpdateGroupError,
        Schemas.SaveGroupRequest,
        {},
        {},
        AccessUpdateGroupPathParams
    >({
        url: '/api/access/groups/{groupId}',
        method: 'put',
        ...variables,
        signal,
    });

export const useAccessUpdateGroup = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.GroupAccess,
            AccessUpdateGroupError,
            AccessUpdateGroupVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.GroupAccess,
        AccessUpdateGroupError,
        AccessUpdateGroupVariables
    >({
        mutationFn: (variables: AccessUpdateGroupVariables) =>
            fetchAccessUpdateGroup({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessRemoveGroupPathParams = {
    /**
     * @format uuid
     */
    groupId: string;
};

export type AccessRemoveGroupError = Fetcher.ErrorWrapper<undefined>;

export type AccessRemoveGroupVariables = {
    pathParams: AccessRemoveGroupPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessRemoveGroup = (
    variables: AccessRemoveGroupVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        AccessRemoveGroupError,
        undefined,
        {},
        {},
        AccessRemoveGroupPathParams
    >({
        url: '/api/access/groups/{groupId}',
        method: 'delete',
        ...variables,
        signal,
    });

export const useAccessRemoveGroup = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            AccessRemoveGroupError,
            AccessRemoveGroupVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        AccessRemoveGroupError,
        AccessRemoveGroupVariables
    >({
        mutationFn: (variables: AccessRemoveGroupVariables) =>
            fetchAccessRemoveGroup({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessGroupMembersPathParams = {
    /**
     * @format uuid
     */
    groupId: string;
};

export type AccessGroupMembersError = Fetcher.ErrorWrapper<undefined>;

export type AccessGroupMembersResponse = Schemas.GroupMemberSummary[];

export type AccessGroupMembersVariables = {
    pathParams: AccessGroupMembersPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessGroupMembers = (
    variables: AccessGroupMembersVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        AccessGroupMembersResponse,
        AccessGroupMembersError,
        undefined,
        {},
        {},
        AccessGroupMembersPathParams
    >({
        url: '/api/access/groups/{groupId}/members',
        method: 'get',
        ...variables,
        signal,
    });

export const useAccessGroupMembers = <TData = AccessGroupMembersResponse>(
    variables: AccessGroupMembersVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            AccessGroupMembersResponse,
            AccessGroupMembersError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        AccessGroupMembersResponse,
        AccessGroupMembersError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/access/groups/{groupId}/members',
            operationId: 'accessGroupMembers',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchAccessGroupMembers(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type AccessAddGroupMemberPathParams = {
    /**
     * @format uuid
     */
    groupId: string;
    /**
     * @format uuid
     */
    userId: string;
};

export type AccessAddGroupMemberError = Fetcher.ErrorWrapper<undefined>;

export type AccessAddGroupMemberVariables = {
    pathParams: AccessAddGroupMemberPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessAddGroupMember = (
    variables: AccessAddGroupMemberVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        AccessAddGroupMemberError,
        undefined,
        {},
        {},
        AccessAddGroupMemberPathParams
    >({
        url: '/api/access/groups/{groupId}/members/{userId}',
        method: 'put',
        ...variables,
        signal,
    });

export const useAccessAddGroupMember = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            AccessAddGroupMemberError,
            AccessAddGroupMemberVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        AccessAddGroupMemberError,
        AccessAddGroupMemberVariables
    >({
        mutationFn: (variables: AccessAddGroupMemberVariables) =>
            fetchAccessAddGroupMember({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessRemoveGroupMemberPathParams = {
    /**
     * @format uuid
     */
    groupId: string;
    /**
     * @format uuid
     */
    userId: string;
};

export type AccessRemoveGroupMemberError = Fetcher.ErrorWrapper<undefined>;

export type AccessRemoveGroupMemberVariables = {
    pathParams: AccessRemoveGroupMemberPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessRemoveGroupMember = (
    variables: AccessRemoveGroupMemberVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.MemberRemoval,
        AccessRemoveGroupMemberError,
        undefined,
        {},
        {},
        AccessRemoveGroupMemberPathParams
    >({
        url: '/api/access/groups/{groupId}/members/{userId}',
        method: 'delete',
        ...variables,
        signal,
    });

export const useAccessRemoveGroupMember = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.MemberRemoval,
            AccessRemoveGroupMemberError,
            AccessRemoveGroupMemberVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.MemberRemoval,
        AccessRemoveGroupMemberError,
        AccessRemoveGroupMemberVariables
    >({
        mutationFn: (variables: AccessRemoveGroupMemberVariables) =>
            fetchAccessRemoveGroupMember({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessSynchroniseGroupPathParams = {
    /**
     * @format uuid
     */
    groupId: string;
};

export type AccessSynchroniseGroupError = Fetcher.ErrorWrapper<{
    status: 409;
    payload: Schemas.ProblemDetails & {
        /**
         * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
         */
        currentVersion?: string | null;
    };
}>;

export type AccessSynchroniseGroupVariables = {
    pathParams: AccessSynchroniseGroupPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessSynchroniseGroup = (
    variables: AccessSynchroniseGroupVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.GroupSynchronisation,
        AccessSynchroniseGroupError,
        undefined,
        {},
        {},
        AccessSynchroniseGroupPathParams
    >({
        url: '/api/access/groups/{groupId}/sync',
        method: 'post',
        ...variables,
        signal,
    });

export const useAccessSynchroniseGroup = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.GroupSynchronisation,
            AccessSynchroniseGroupError,
            AccessSynchroniseGroupVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.GroupSynchronisation,
        AccessSynchroniseGroupError,
        AccessSynchroniseGroupVariables
    >({
        mutationFn: (variables: AccessSynchroniseGroupVariables) =>
            fetchAccessSynchroniseGroup({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type AccessGrantPermissionToGroupPathParams = {
    /**
     * @format uuid
     */
    groupId: string;
    permission: string;
};

export type AccessGrantPermissionToGroupError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.ProblemDetails;
}>;

export type AccessGrantPermissionToGroupVariables = {
    pathParams: AccessGrantPermissionToGroupPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessGrantPermissionToGroup = (
    variables: AccessGrantPermissionToGroupVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        AccessGrantPermissionToGroupError,
        undefined,
        {},
        {},
        AccessGrantPermissionToGroupPathParams
    >({
        url: '/api/access/groups/{groupId}/permissions/{permission}',
        method: 'put',
        ...variables,
        signal,
    });

export const useAccessGrantPermissionToGroup = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            AccessGrantPermissionToGroupError,
            AccessGrantPermissionToGroupVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        AccessGrantPermissionToGroupError,
        AccessGrantPermissionToGroupVariables
    >({
        mutationFn: (variables: AccessGrantPermissionToGroupVariables) =>
            fetchAccessGrantPermissionToGroup({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type AccessRevokePermissionFromGroupPathParams = {
    /**
     * @format uuid
     */
    groupId: string;
    permission: string;
};

export type AccessRevokePermissionFromGroupError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.ProblemDetails;
}>;

export type AccessRevokePermissionFromGroupVariables = {
    pathParams: AccessRevokePermissionFromGroupPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessRevokePermissionFromGroup = (
    variables: AccessRevokePermissionFromGroupVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        AccessRevokePermissionFromGroupError,
        undefined,
        {},
        {},
        AccessRevokePermissionFromGroupPathParams
    >({
        url: '/api/access/groups/{groupId}/permissions/{permission}',
        method: 'delete',
        ...variables,
        signal,
    });

export const useAccessRevokePermissionFromGroup = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            AccessRevokePermissionFromGroupError,
            AccessRevokePermissionFromGroupVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        AccessRevokePermissionFromGroupError,
        AccessRevokePermissionFromGroupVariables
    >({
        mutationFn: (variables: AccessRevokePermissionFromGroupVariables) =>
            fetchAccessRevokePermissionFromGroup({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type AccessChangeRecordError = Fetcher.ErrorWrapper<undefined>;

export type AccessChangeRecordResponse = Schemas.AccessChangeRecord[];

export type AccessChangeRecordVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchAccessChangeRecord = (
    variables: AccessChangeRecordVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        AccessChangeRecordResponse,
        AccessChangeRecordError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/access/record', method: 'get', ...variables, signal });

export const useAccessChangeRecord = <TData = AccessChangeRecordResponse>(
    variables: AccessChangeRecordVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            AccessChangeRecordResponse,
            AccessChangeRecordError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        AccessChangeRecordResponse,
        AccessChangeRecordError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/access/record',
            operationId: 'accessChangeRecord',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchAccessChangeRecord(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type AccessDirectoryAvailableError = Fetcher.ErrorWrapper<undefined>;

export type AccessDirectoryAvailableVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchAccessDirectoryAvailable = (
    variables: AccessDirectoryAvailableVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.DirectoryAvailability,
        AccessDirectoryAvailableError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/access/directory', method: 'get', ...variables, signal });

export const useAccessDirectoryAvailable = <
    TData = Schemas.DirectoryAvailability,
>(
    variables: AccessDirectoryAvailableVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.DirectoryAvailability,
            AccessDirectoryAvailableError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.DirectoryAvailability,
        AccessDirectoryAvailableError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/access/directory',
            operationId: 'accessDirectoryAvailable',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchAccessDirectoryAvailable(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type AccessSearchDirectoryPeopleQueryParams = {
    query?: string;
};

export type AccessSearchDirectoryPeopleError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.ProblemDetails;
}>;

export type AccessSearchDirectoryPeopleVariables = {
    queryParams?: AccessSearchDirectoryPeopleQueryParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessSearchDirectoryPeople = (
    variables: AccessSearchDirectoryPeopleVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.DirectoryPersonDirectorySearchResult,
        AccessSearchDirectoryPeopleError,
        undefined,
        {},
        AccessSearchDirectoryPeopleQueryParams,
        {}
    >({
        url: '/api/access/directory/people',
        method: 'get',
        ...variables,
        signal,
    });

export const useAccessSearchDirectoryPeople = <
    TData = Schemas.DirectoryPersonDirectorySearchResult,
>(
    variables: AccessSearchDirectoryPeopleVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.DirectoryPersonDirectorySearchResult,
            AccessSearchDirectoryPeopleError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.DirectoryPersonDirectorySearchResult,
        AccessSearchDirectoryPeopleError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/access/directory/people',
            operationId: 'accessSearchDirectoryPeople',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchAccessSearchDirectoryPeople(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type AccessSearchDirectoryGroupsQueryParams = {
    query?: string;
};

export type AccessSearchDirectoryGroupsError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.ProblemDetails;
}>;

export type AccessSearchDirectoryGroupsVariables = {
    queryParams?: AccessSearchDirectoryGroupsQueryParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchAccessSearchDirectoryGroups = (
    variables: AccessSearchDirectoryGroupsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.DirectoryGroupDirectorySearchResult,
        AccessSearchDirectoryGroupsError,
        undefined,
        {},
        AccessSearchDirectoryGroupsQueryParams,
        {}
    >({
        url: '/api/access/directory/groups',
        method: 'get',
        ...variables,
        signal,
    });

export const useAccessSearchDirectoryGroups = <
    TData = Schemas.DirectoryGroupDirectorySearchResult,
>(
    variables: AccessSearchDirectoryGroupsVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.DirectoryGroupDirectorySearchResult,
            AccessSearchDirectoryGroupsError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.DirectoryGroupDirectorySearchResult,
        AccessSearchDirectoryGroupsError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/access/directory/groups',
            operationId: 'accessSearchDirectoryGroups',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchAccessSearchDirectoryGroups(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type GetWhoAmIError = Fetcher.ErrorWrapper<undefined>;

export type GetWhoAmIVariables = ConnectorNextContext['fetcherOptions'];

export const fetchGetWhoAmI = (
    variables: GetWhoAmIVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.WhoAmIResponse,
        GetWhoAmIError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/auth/whoami', method: 'get', ...variables, signal });

export const useGetWhoAmI = <TData = Schemas.WhoAmIResponse>(
    variables: GetWhoAmIVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.WhoAmIResponse,
            GetWhoAmIError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<Schemas.WhoAmIResponse, GetWhoAmIError, TData>({
        queryKey: queryKeyFn({
            path: '/api/auth/whoami',
            operationId: 'getWhoAmI',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchGetWhoAmI({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type BootstrapStatusError = Fetcher.ErrorWrapper<undefined>;

export type BootstrapStatusVariables = ConnectorNextContext['fetcherOptions'];

export const fetchBootstrapStatus = (
    variables: BootstrapStatusVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.BootstrapResponse,
        BootstrapStatusError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/access/bootstrap', method: 'get', ...variables, signal });

export const useBootstrapStatus = <TData = Schemas.BootstrapResponse>(
    variables: BootstrapStatusVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.BootstrapResponse,
            BootstrapStatusError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.BootstrapResponse,
        BootstrapStatusError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/access/bootstrap',
            operationId: 'bootstrapStatus',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchBootstrapStatus({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type BootstrapAdoptError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
>;

export type BootstrapAdoptVariables = ConnectorNextContext['fetcherOptions'];

export const fetchBootstrapAdopt = (
    variables: BootstrapAdoptVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.UserAccess,
        BootstrapAdoptError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/access/bootstrap', method: 'post', ...variables, signal });

export const useBootstrapAdopt = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.UserAccess,
            BootstrapAdoptError,
            BootstrapAdoptVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.UserAccess,
        BootstrapAdoptError,
        BootstrapAdoptVariables
    >({
        mutationFn: (variables: BootstrapAdoptVariables) =>
            fetchBootstrapAdopt({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type BreakGlassIssueError = Fetcher.ErrorWrapper<undefined>;

export type BreakGlassIssueVariables = {
    body?: Schemas.IssueCodeRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchBreakGlassIssue = (
    variables: BreakGlassIssueVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.IssuedCode,
        BreakGlassIssueError,
        Schemas.IssueCodeRequest,
        {},
        {},
        {}
    >({ url: '/api/break-glass/codes', method: 'post', ...variables, signal });

export const useBreakGlassIssue = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.IssuedCode,
            BreakGlassIssueError,
            BreakGlassIssueVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.IssuedCode,
        BreakGlassIssueError,
        BreakGlassIssueVariables
    >({
        mutationFn: (variables: BreakGlassIssueVariables) =>
            fetchBreakGlassIssue({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type BreakGlassCodesError = Fetcher.ErrorWrapper<undefined>;

export type BreakGlassCodesResponse = Schemas.BreakGlassCodeStatus[];

export type BreakGlassCodesVariables = ConnectorNextContext['fetcherOptions'];

export const fetchBreakGlassCodes = (
    variables: BreakGlassCodesVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        BreakGlassCodesResponse,
        BreakGlassCodesError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/break-glass/codes', method: 'get', ...variables, signal });

export const useBreakGlassCodes = <TData = BreakGlassCodesResponse>(
    variables: BreakGlassCodesVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            BreakGlassCodesResponse,
            BreakGlassCodesError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        BreakGlassCodesResponse,
        BreakGlassCodesError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/break-glass/codes',
            operationId: 'breakGlassCodes',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchBreakGlassCodes({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type BreakGlassRevokePathParams = {
    /**
     * @format uuid
     */
    codeId: string;
};

export type BreakGlassRevokeError = Fetcher.ErrorWrapper<undefined>;

export type BreakGlassRevokeVariables = {
    pathParams: BreakGlassRevokePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchBreakGlassRevoke = (
    variables: BreakGlassRevokeVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        BreakGlassRevokeError,
        undefined,
        {},
        {},
        BreakGlassRevokePathParams
    >({
        url: '/api/break-glass/codes/{codeId}',
        method: 'delete',
        ...variables,
        signal,
    });

export const useBreakGlassRevoke = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            BreakGlassRevokeError,
            BreakGlassRevokeVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        BreakGlassRevokeError,
        BreakGlassRevokeVariables
    >({
        mutationFn: (variables: BreakGlassRevokeVariables) =>
            fetchBreakGlassRevoke({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type BreakGlassRecordError = Fetcher.ErrorWrapper<undefined>;

export type BreakGlassRecordResponse = Schemas.BreakGlassRecord[];

export type BreakGlassRecordVariables = ConnectorNextContext['fetcherOptions'];

export const fetchBreakGlassRecord = (
    variables: BreakGlassRecordVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        BreakGlassRecordResponse,
        BreakGlassRecordError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/break-glass/record', method: 'get', ...variables, signal });

export const useBreakGlassRecord = <TData = BreakGlassRecordResponse>(
    variables: BreakGlassRecordVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            BreakGlassRecordResponse,
            BreakGlassRecordError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        BreakGlassRecordResponse,
        BreakGlassRecordError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/break-glass/record',
            operationId: 'breakGlassRecord',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchBreakGlassRecord({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type BreakGlassRedeemError = Fetcher.ErrorWrapper<
    | {
          status: 401;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 429;
          payload: Schemas.ProblemDetails;
      }
>;

export type BreakGlassRedeemVariables = {
    body?: Schemas.RedeemCodeRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchBreakGlassRedeem = (
    variables: BreakGlassRedeemVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.RedemptionResult,
        BreakGlassRedeemError,
        Schemas.RedeemCodeRequest,
        {},
        {},
        {}
    >({ url: '/api/break-glass/redeem', method: 'post', ...variables, signal });

export const useBreakGlassRedeem = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.RedemptionResult,
            BreakGlassRedeemError,
            BreakGlassRedeemVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.RedemptionResult,
        BreakGlassRedeemError,
        BreakGlassRedeemVariables
    >({
        mutationFn: (variables: BreakGlassRedeemVariables) =>
            fetchBreakGlassRedeem({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type BreakGlassLocalAdministratorError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type BreakGlassLocalAdministratorVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchBreakGlassLocalAdministrator = (
    variables: BreakGlassLocalAdministratorVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.LocalAdministratorStatus,
        BreakGlassLocalAdministratorError,
        undefined,
        {},
        {},
        {}
    >({
        url: '/api/break-glass/local-administrator',
        method: 'get',
        ...variables,
        signal,
    });

export const useBreakGlassLocalAdministrator = <
    TData = Schemas.LocalAdministratorStatus,
>(
    variables: BreakGlassLocalAdministratorVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.LocalAdministratorStatus,
            BreakGlassLocalAdministratorError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.LocalAdministratorStatus,
        BreakGlassLocalAdministratorError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/break-glass/local-administrator',
            operationId: 'breakGlassLocalAdministrator',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchBreakGlassLocalAdministrator(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type BreakGlassSetLocalAdministratorError = Fetcher.ErrorWrapper<{
    status: 409;
    payload: Schemas.ProblemDetails & {
        /**
         * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
         */
        currentVersion?: string | null;
    };
}>;

export type BreakGlassSetLocalAdministratorVariables = {
    body?: Schemas.SetLocalAdministratorRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchBreakGlassSetLocalAdministrator = (
    variables: BreakGlassSetLocalAdministratorVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        BreakGlassSetLocalAdministratorError,
        Schemas.SetLocalAdministratorRequest,
        {},
        {},
        {}
    >({
        url: '/api/break-glass/local-administrator',
        method: 'put',
        ...variables,
        signal,
    });

export const useBreakGlassSetLocalAdministrator = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            BreakGlassSetLocalAdministratorError,
            BreakGlassSetLocalAdministratorVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        BreakGlassSetLocalAdministratorError,
        BreakGlassSetLocalAdministratorVariables
    >({
        mutationFn: (variables: BreakGlassSetLocalAdministratorVariables) =>
            fetchBreakGlassSetLocalAdministrator({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type BreakGlassRemoveLocalAdministratorError =
    Fetcher.ErrorWrapper<undefined>;

export type BreakGlassRemoveLocalAdministratorVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchBreakGlassRemoveLocalAdministrator = (
    variables: BreakGlassRemoveLocalAdministratorVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        BreakGlassRemoveLocalAdministratorError,
        undefined,
        {},
        {},
        {}
    >({
        url: '/api/break-glass/local-administrator',
        method: 'delete',
        ...variables,
        signal,
    });

export const useBreakGlassRemoveLocalAdministrator = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            BreakGlassRemoveLocalAdministratorError,
            BreakGlassRemoveLocalAdministratorVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        BreakGlassRemoveLocalAdministratorError,
        BreakGlassRemoveLocalAdministratorVariables
    >({
        mutationFn: (variables: BreakGlassRemoveLocalAdministratorVariables) =>
            fetchBreakGlassRemoveLocalAdministrator({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type BreakGlassSignInError = Fetcher.ErrorWrapper<
    | {
          status: 401;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 429;
          payload: Schemas.ProblemDetails;
      }
>;

export type BreakGlassSignInVariables = {
    body?: Schemas.LocalSignInRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchBreakGlassSignIn = (
    variables: BreakGlassSignInVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.RedemptionResult,
        BreakGlassSignInError,
        Schemas.LocalSignInRequest,
        {},
        {},
        {}
    >({
        url: '/api/break-glass/sign-in',
        method: 'post',
        ...variables,
        signal,
    });

export const useBreakGlassSignIn = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.RedemptionResult,
            BreakGlassSignInError,
            BreakGlassSignInVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.RedemptionResult,
        BreakGlassSignInError,
        BreakGlassSignInVariables
    >({
        mutationFn: (variables: BreakGlassSignInVariables) =>
            fetchBreakGlassSignIn({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type BreakGlassEndError = Fetcher.ErrorWrapper<undefined>;

export type BreakGlassEndVariables = ConnectorNextContext['fetcherOptions'];

export const fetchBreakGlassEnd = (
    variables: BreakGlassEndVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<undefined, BreakGlassEndError, undefined, {}, {}, {}>({
        url: '/api/break-glass/end',
        method: 'post',
        ...variables,
        signal,
    });

export const useBreakGlassEnd = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            BreakGlassEndError,
            BreakGlassEndVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        BreakGlassEndError,
        BreakGlassEndVariables
    >({
        mutationFn: (variables: BreakGlassEndVariables) =>
            fetchBreakGlassEnd({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type ClinicalListsListTagsError = Fetcher.ErrorWrapper<undefined>;

export type ClinicalListsListTagsResponse = Schemas.ClinicalTagDto[];

export type ClinicalListsListTagsVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchClinicalListsListTags = (
    variables: ClinicalListsListTagsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        ClinicalListsListTagsResponse,
        ClinicalListsListTagsError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/clinical-tags', method: 'get', ...variables, signal });

export const useClinicalListsListTags = <TData = ClinicalListsListTagsResponse>(
    variables: ClinicalListsListTagsVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            ClinicalListsListTagsResponse,
            ClinicalListsListTagsError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        ClinicalListsListTagsResponse,
        ClinicalListsListTagsError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/clinical-tags',
            operationId: 'clinicalListsListTags',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchClinicalListsListTags(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type ClinicalListsAddTagError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.ProblemDetails;
}>;

export type ClinicalListsAddTagVariables = {
    body?: Schemas.AddClinicalTagRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchClinicalListsAddTag = (
    variables: ClinicalListsAddTagVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.ClinicalTagDto,
        ClinicalListsAddTagError,
        Schemas.AddClinicalTagRequest,
        {},
        {},
        {}
    >({ url: '/api/clinical-tags', method: 'post', ...variables, signal });

export const useClinicalListsAddTag = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.ClinicalTagDto,
            ClinicalListsAddTagError,
            ClinicalListsAddTagVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.ClinicalTagDto,
        ClinicalListsAddTagError,
        ClinicalListsAddTagVariables
    >({
        mutationFn: (variables: ClinicalListsAddTagVariables) =>
            fetchClinicalListsAddTag({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type ClinicalListsChangeTagPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type ClinicalListsChangeTagError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type ClinicalListsChangeTagVariables = {
    body?: Schemas.ChangeClinicalTagRequest;
    pathParams: ClinicalListsChangeTagPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchClinicalListsChangeTag = (
    variables: ClinicalListsChangeTagVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.ClinicalTagDto,
        ClinicalListsChangeTagError,
        Schemas.ChangeClinicalTagRequest,
        {},
        {},
        ClinicalListsChangeTagPathParams
    >({ url: '/api/clinical-tags/{id}', method: 'put', ...variables, signal });

export const useClinicalListsChangeTag = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.ClinicalTagDto,
            ClinicalListsChangeTagError,
            ClinicalListsChangeTagVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.ClinicalTagDto,
        ClinicalListsChangeTagError,
        ClinicalListsChangeTagVariables
    >({
        mutationFn: (variables: ClinicalListsChangeTagVariables) =>
            fetchClinicalListsChangeTag({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type ClinicalListsListSitesError = Fetcher.ErrorWrapper<undefined>;

export type ClinicalListsListSitesResponse = Schemas.TreatmentSiteDto[];

export type ClinicalListsListSitesVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchClinicalListsListSites = (
    variables: ClinicalListsListSitesVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        ClinicalListsListSitesResponse,
        ClinicalListsListSitesError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/treatment-sites', method: 'get', ...variables, signal });

export const useClinicalListsListSites = <
    TData = ClinicalListsListSitesResponse,
>(
    variables: ClinicalListsListSitesVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            ClinicalListsListSitesResponse,
            ClinicalListsListSitesError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        ClinicalListsListSitesResponse,
        ClinicalListsListSitesError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/treatment-sites',
            operationId: 'clinicalListsListSites',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchClinicalListsListSites(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type ClinicalListsAddSiteError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.ProblemDetails;
}>;

export type ClinicalListsAddSiteVariables = {
    body?: Schemas.AddTreatmentSiteRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchClinicalListsAddSite = (
    variables: ClinicalListsAddSiteVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TreatmentSiteDto,
        ClinicalListsAddSiteError,
        Schemas.AddTreatmentSiteRequest,
        {},
        {},
        {}
    >({ url: '/api/treatment-sites', method: 'post', ...variables, signal });

export const useClinicalListsAddSite = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.TreatmentSiteDto,
            ClinicalListsAddSiteError,
            ClinicalListsAddSiteVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.TreatmentSiteDto,
        ClinicalListsAddSiteError,
        ClinicalListsAddSiteVariables
    >({
        mutationFn: (variables: ClinicalListsAddSiteVariables) =>
            fetchClinicalListsAddSite({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type ClinicalListsChangeSitePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type ClinicalListsChangeSiteError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type ClinicalListsChangeSiteVariables = {
    body?: Schemas.ChangeTreatmentSiteRequest;
    pathParams: ClinicalListsChangeSitePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchClinicalListsChangeSite = (
    variables: ClinicalListsChangeSiteVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TreatmentSiteDto,
        ClinicalListsChangeSiteError,
        Schemas.ChangeTreatmentSiteRequest,
        {},
        {},
        ClinicalListsChangeSitePathParams
    >({
        url: '/api/treatment-sites/{id}',
        method: 'put',
        ...variables,
        signal,
    });

export const useClinicalListsChangeSite = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.TreatmentSiteDto,
            ClinicalListsChangeSiteError,
            ClinicalListsChangeSiteVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.TreatmentSiteDto,
        ClinicalListsChangeSiteError,
        ClinicalListsChangeSiteVariables
    >({
        mutationFn: (variables: ClinicalListsChangeSiteVariables) =>
            fetchClinicalListsChangeSite({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type ClinicalListsListPeopleError = Fetcher.ErrorWrapper<undefined>;

export type ClinicalListsListPeopleVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchClinicalListsListPeople = (
    variables: ClinicalListsListPeopleVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.ClinicalPeopleList,
        ClinicalListsListPeopleError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/clinical-people', method: 'get', ...variables, signal });

export const useClinicalListsListPeople = <TData = Schemas.ClinicalPeopleList>(
    variables: ClinicalListsListPeopleVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.ClinicalPeopleList,
            ClinicalListsListPeopleError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.ClinicalPeopleList,
        ClinicalListsListPeopleError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/clinical-people',
            operationId: 'clinicalListsListPeople',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchClinicalListsListPeople(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type ConfigurationReadError = Fetcher.ErrorWrapper<undefined>;

export type ConfigurationReadVariables = ConnectorNextContext['fetcherOptions'];

export const fetchConfigurationRead = (
    variables: ConfigurationReadVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.ConfigurationReport,
        ConfigurationReadError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/configuration', method: 'get', ...variables, signal });

export const useConfigurationRead = <TData = Schemas.ConfigurationReport>(
    variables: ConfigurationReadVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.ConfigurationReport,
            ConfigurationReadError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.ConfigurationReport,
        ConfigurationReadError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/configuration',
            operationId: 'configurationRead',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchConfigurationRead({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type ConfigurationSaveError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
>;

export type ConfigurationSaveVariables = {
    body?: Schemas.SaveSettingRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchConfigurationSave = (
    variables: ConfigurationSaveVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.ConfiguredSetting,
        ConfigurationSaveError,
        Schemas.SaveSettingRequest,
        {},
        {},
        {}
    >({ url: '/api/configuration', method: 'put', ...variables, signal });

export const useConfigurationSave = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.ConfiguredSetting,
            ConfigurationSaveError,
            ConfigurationSaveVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.ConfiguredSetting,
        ConfigurationSaveError,
        ConfigurationSaveVariables
    >({
        mutationFn: (variables: ConfigurationSaveVariables) =>
            fetchConfigurationSave({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type ConfigurationReadAuthenticationError =
    Fetcher.ErrorWrapper<undefined>;

export type ConfigurationReadAuthenticationVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchConfigurationReadAuthentication = (
    variables: ConfigurationReadAuthenticationVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.AuthenticationSetup,
        ConfigurationReadAuthenticationError,
        undefined,
        {},
        {},
        {}
    >({
        url: '/api/configuration/authentication',
        method: 'get',
        ...variables,
        signal,
    });

export const useConfigurationReadAuthentication = <
    TData = Schemas.AuthenticationSetup,
>(
    variables: ConfigurationReadAuthenticationVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.AuthenticationSetup,
            ConfigurationReadAuthenticationError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.AuthenticationSetup,
        ConfigurationReadAuthenticationError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/configuration/authentication',
            operationId: 'configurationReadAuthentication',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchConfigurationReadAuthentication(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type ConfigurationSaveAuthenticationError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
>;

export type ConfigurationSaveAuthenticationVariables = {
    body?: Schemas.AuthenticationModeRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchConfigurationSaveAuthentication = (
    variables: ConfigurationSaveAuthenticationVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.AuthenticationSetup,
        ConfigurationSaveAuthenticationError,
        Schemas.AuthenticationModeRequest,
        {},
        {},
        {}
    >({
        url: '/api/configuration/authentication',
        method: 'put',
        ...variables,
        signal,
    });

export const useConfigurationSaveAuthentication = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.AuthenticationSetup,
            ConfigurationSaveAuthenticationError,
            ConfigurationSaveAuthenticationVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.AuthenticationSetup,
        ConfigurationSaveAuthenticationError,
        ConfigurationSaveAuthenticationVariables
    >({
        mutationFn: (variables: ConfigurationSaveAuthenticationVariables) =>
            fetchConfigurationSaveAuthentication({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type ConfigurationReadPeersError = Fetcher.ErrorWrapper<undefined>;

export type ConfigurationReadPeersResponse = Schemas.DicomPeer[];

export type ConfigurationReadPeersVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchConfigurationReadPeers = (
    variables: ConfigurationReadPeersVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        ConfigurationReadPeersResponse,
        ConfigurationReadPeersError,
        undefined,
        {},
        {},
        {}
    >({
        url: '/api/configuration/dicom-peers',
        method: 'get',
        ...variables,
        signal,
    });

export const useConfigurationReadPeers = <
    TData = ConfigurationReadPeersResponse,
>(
    variables: ConfigurationReadPeersVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            ConfigurationReadPeersResponse,
            ConfigurationReadPeersError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        ConfigurationReadPeersResponse,
        ConfigurationReadPeersError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/configuration/dicom-peers',
            operationId: 'configurationReadPeers',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchConfigurationReadPeers(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type ConfigurationSavePeersError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
>;

export type ConfigurationSavePeersResponse = Schemas.DicomPeer[];

export type ConfigurationSavePeersRequestBody = Schemas.DicomPeer[];

export type ConfigurationSavePeersVariables = {
    body?: ConfigurationSavePeersRequestBody;
} & ConnectorNextContext['fetcherOptions'];

export const fetchConfigurationSavePeers = (
    variables: ConfigurationSavePeersVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        ConfigurationSavePeersResponse,
        ConfigurationSavePeersError,
        ConfigurationSavePeersRequestBody,
        {},
        {},
        {}
    >({
        url: '/api/configuration/dicom-peers',
        method: 'put',
        ...variables,
        signal,
    });

export const useConfigurationSavePeers = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            ConfigurationSavePeersResponse,
            ConfigurationSavePeersError,
            ConfigurationSavePeersVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        ConfigurationSavePeersResponse,
        ConfigurationSavePeersError,
        ConfigurationSavePeersVariables
    >({
        mutationFn: (variables: ConfigurationSavePeersVariables) =>
            fetchConfigurationSavePeers({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type ConfigurationEchoError = Fetcher.ErrorWrapper<undefined>;

export type ConfigurationEchoVariables = {
    body?: Schemas.DicomPeer;
} & ConnectorNextContext['fetcherOptions'];

export const fetchConfigurationEcho = (
    variables: ConfigurationEchoVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.PeerEchoResult,
        ConfigurationEchoError,
        Schemas.DicomPeer,
        {},
        {},
        {}
    >({
        url: '/api/configuration/dicom-peers/echo',
        method: 'post',
        ...variables,
        signal,
    });

export const useConfigurationEcho = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.PeerEchoResult,
            ConfigurationEchoError,
            ConfigurationEchoVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.PeerEchoResult,
        ConfigurationEchoError,
        ConfigurationEchoVariables
    >({
        mutationFn: (variables: ConfigurationEchoVariables) =>
            fetchConfigurationEcho({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type DataRetrievalGetSeriesZipPathParams = {
    studyUid: string;
    seriesUid: string;
};

export type DataRetrievalGetSeriesZipError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type DataRetrievalGetSeriesZipVariables = {
    pathParams: DataRetrievalGetSeriesZipPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDataRetrievalGetSeriesZip = (
    variables: DataRetrievalGetSeriesZipVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.SeriesTransferStatusResponse,
        DataRetrievalGetSeriesZipError,
        undefined,
        {},
        {},
        DataRetrievalGetSeriesZipPathParams
    >({
        url: '/api/studies/{studyUid}/series/{seriesUid}.zip',
        method: 'get',
        ...variables,
        signal,
    });

export const useDataRetrievalGetSeriesZip = <
    TData = Schemas.SeriesTransferStatusResponse,
>(
    variables: DataRetrievalGetSeriesZipVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.SeriesTransferStatusResponse,
            DataRetrievalGetSeriesZipError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.SeriesTransferStatusResponse,
        DataRetrievalGetSeriesZipError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/studies/{studyUid}/series/{seriesUid}.zip',
            operationId: 'dataRetrievalGetSeriesZip',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchDataRetrievalGetSeriesZip(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type DataRetrievalGetInstancePathParams = {
    studyUid: string;
    seriesUid: string;
    sopUid: string;
};

export type DataRetrievalGetInstanceError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type DataRetrievalGetInstanceVariables = {
    pathParams: DataRetrievalGetInstancePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDataRetrievalGetInstance = (
    variables: DataRetrievalGetInstanceVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.InstanceTransferStatusResponse,
        DataRetrievalGetInstanceError,
        undefined,
        {},
        {},
        DataRetrievalGetInstancePathParams
    >({
        url: '/api/studies/{studyUid}/series/{seriesUid}/instances/{sopUid}.dcm',
        method: 'get',
        ...variables,
        signal,
    });

export const useDataRetrievalGetInstance = <
    TData = Schemas.InstanceTransferStatusResponse,
>(
    variables: DataRetrievalGetInstanceVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.InstanceTransferStatusResponse,
            DataRetrievalGetInstanceError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.InstanceTransferStatusResponse,
        DataRetrievalGetInstanceError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/studies/{studyUid}/series/{seriesUid}/instances/{sopUid}.dcm',
            operationId: 'dataRetrievalGetInstance',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchDataRetrievalGetInstance(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type DicomListTargetsError = Fetcher.ErrorWrapper<undefined>;

export type DicomListTargetsResponse = Schemas.DicomTargetHealthDto[];

export type DicomListTargetsVariables = ConnectorNextContext['fetcherOptions'];

export const fetchDicomListTargets = (
    variables: DicomListTargetsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        DicomListTargetsResponse,
        DicomListTargetsError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/dicom/targets', method: 'get', ...variables, signal });

export const useDicomListTargets = <TData = DicomListTargetsResponse>(
    variables: DicomListTargetsVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            DicomListTargetsResponse,
            DicomListTargetsError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        DicomListTargetsResponse,
        DicomListTargetsError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/dicom/targets',
            operationId: 'dicomListTargets',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchDicomListTargets({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type DicomQueryPatientsQueryParams = {
    target?: string;
    search?: string;
};

export type DicomQueryPatientsError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type DicomQueryPatientsVariables = {
    queryParams?: DicomQueryPatientsQueryParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDicomQueryPatients = (
    variables: DicomQueryPatientsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.RemotePatientQueryResultDto,
        DicomQueryPatientsError,
        undefined,
        {},
        DicomQueryPatientsQueryParams,
        {}
    >({ url: '/api/dicom/patients', method: 'get', ...variables, signal });

export const useDicomQueryPatients = <
    TData = Schemas.RemotePatientQueryResultDto,
>(
    variables: DicomQueryPatientsVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.RemotePatientQueryResultDto,
            DicomQueryPatientsError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.RemotePatientQueryResultDto,
        DicomQueryPatientsError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/dicom/patients',
            operationId: 'dicomQueryPatients',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchDicomQueryPatients(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type DicomQueryQueryParams = {
    patientId?: string;
    target?: string;
};

export type DicomQueryError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type DicomQueryVariables = {
    queryParams?: DicomQueryQueryParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDicomQuery = (
    variables: DicomQueryVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.RemoteQueryResultDto,
        DicomQueryError,
        undefined,
        {},
        DicomQueryQueryParams,
        {}
    >({ url: '/api/dicom/query', method: 'get', ...variables, signal });

export const useDicomQuery = <TData = Schemas.RemoteQueryResultDto>(
    variables: DicomQueryVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.RemoteQueryResultDto,
            DicomQueryError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.RemoteQueryResultDto,
        DicomQueryError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/dicom/query',
            operationId: 'dicomQuery',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchDicomQuery({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type DicomRetrieveError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type DicomRetrieveVariables = {
    body?: Schemas.RetrieveSeriesRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDicomRetrieve = (
    variables: DicomRetrieveVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.RetrieveStartedDto,
        DicomRetrieveError,
        Schemas.RetrieveSeriesRequest,
        {},
        {},
        {}
    >({ url: '/api/dicom/retrieve', method: 'post', ...variables, signal });

export const useDicomRetrieve = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.RetrieveStartedDto,
            DicomRetrieveError,
            DicomRetrieveVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.RetrieveStartedDto,
        DicomRetrieveError,
        DicomRetrieveVariables
    >({
        mutationFn: (variables: DicomRetrieveVariables) =>
            fetchDicomRetrieve({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type DicomCancelRetrievalsError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.ProblemDetails;
}>;

export type DicomCancelRetrievalsResponse = Schemas.RetrievalCancelDto[];

export type DicomCancelRetrievalsVariables = {
    body?: Schemas.CancelRetrievalsRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDicomCancelRetrievals = (
    variables: DicomCancelRetrievalsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        DicomCancelRetrievalsResponse,
        DicomCancelRetrievalsError,
        Schemas.CancelRetrievalsRequest,
        {},
        {},
        {}
    >({
        url: '/api/dicom/retrievals/cancel',
        method: 'post',
        ...variables,
        signal,
    });

export const useDicomCancelRetrievals = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            DicomCancelRetrievalsResponse,
            DicomCancelRetrievalsError,
            DicomCancelRetrievalsVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        DicomCancelRetrievalsResponse,
        DicomCancelRetrievalsError,
        DicomCancelRetrievalsVariables
    >({
        mutationFn: (variables: DicomCancelRetrievalsVariables) =>
            fetchDicomCancelRetrievals({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type DicomRetryRetrievalPathParams = {
    /**
     * @format uuid
     */
    retrievalId: string;
};

export type DicomRetryRetrievalError = Fetcher.ErrorWrapper<
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
>;

export type DicomRetryRetrievalVariables = {
    pathParams: DicomRetryRetrievalPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDicomRetryRetrieval = (
    variables: DicomRetryRetrievalVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.RetrieveStartedDto,
        DicomRetryRetrievalError,
        undefined,
        {},
        {},
        DicomRetryRetrievalPathParams
    >({
        url: '/api/dicom/retrievals/{retrievalId}/retry',
        method: 'post',
        ...variables,
        signal,
    });

export const useDicomRetryRetrieval = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.RetrieveStartedDto,
            DicomRetryRetrievalError,
            DicomRetryRetrievalVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.RetrieveStartedDto,
        DicomRetryRetrievalError,
        DicomRetryRetrievalVariables
    >({
        mutationFn: (variables: DicomRetryRetrievalVariables) =>
            fetchDicomRetryRetrieval({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type DicomRetrievalsQueryParams = {
    ids?: string;
};

export type DicomRetrievalsError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.ProblemDetails;
}>;

export type DicomRetrievalsResponse = Schemas.RetrievalStatusDto[];

export type DicomRetrievalsVariables = {
    queryParams?: DicomRetrievalsQueryParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDicomRetrievals = (
    variables: DicomRetrievalsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        DicomRetrievalsResponse,
        DicomRetrievalsError,
        undefined,
        {},
        DicomRetrievalsQueryParams,
        {}
    >({ url: '/api/dicom/retrievals', method: 'get', ...variables, signal });

export const useDicomRetrievals = <TData = DicomRetrievalsResponse>(
    variables: DicomRetrievalsVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            DicomRetrievalsResponse,
            DicomRetrievalsError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        DicomRetrievalsResponse,
        DicomRetrievalsError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/dicom/retrievals',
            operationId: 'dicomRetrievals',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchDicomRetrievals({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type DicomInstancesError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type DicomInstancesRequestBody = {
    files?: Blob[];
};

export type DicomInstancesVariables = {
    body?: DicomInstancesRequestBody;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDicomInstances = (
    variables: DicomInstancesVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.ImportInstancesResponse,
        DicomInstancesError,
        DicomInstancesRequestBody,
        {},
        {},
        {}
    >({ url: '/api/dicom/instances', method: 'post', ...variables, signal });

export const useDicomInstances = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.ImportInstancesResponse,
            DicomInstancesError,
            DicomInstancesVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.ImportInstancesResponse,
        DicomInstancesError,
        DicomInstancesVariables
    >({
        mutationFn: (variables: DicomInstancesVariables) =>
            fetchDicomInstances({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type DosesGetByIdPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type DosesGetByIdError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type DosesGetByIdVariables = {
    pathParams: DosesGetByIdPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDosesGetById = (
    variables: DosesGetByIdVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.DoseDetailResponse,
        DosesGetByIdError,
        undefined,
        {},
        {},
        DosesGetByIdPathParams
    >({ url: '/api/doses/{id}', method: 'get', ...variables, signal });

export const useDosesGetById = <TData = Schemas.DoseDetailResponse>(
    variables: DosesGetByIdVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.DoseDetailResponse,
            DosesGetByIdError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.DoseDetailResponse,
        DosesGetByIdError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/doses/{id}',
            operationId: 'dosesGetById',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchDosesGetById({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type DosesDeletePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type DosesDeleteError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
>;

export type DosesDeleteVariables = {
    pathParams: DosesDeletePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchDosesDelete = (
    variables: DosesDeleteVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        DosesDeleteError,
        undefined,
        {},
        {},
        DosesDeletePathParams
    >({ url: '/api/doses/{id}', method: 'delete', ...variables, signal });

export const useDosesDelete = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            DosesDeleteError,
            DosesDeleteVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        DosesDeleteError,
        DosesDeleteVariables
    >({
        mutationFn: (variables: DosesDeleteVariables) =>
            fetchDosesDelete({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type EditingSessionsActiveError = Fetcher.ErrorWrapper<undefined>;

export type EditingSessionsActiveResponse = Schemas.ActiveEditingSessionDto[];

export type EditingSessionsActiveVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchEditingSessionsActive = (
    variables: EditingSessionsActiveVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        EditingSessionsActiveResponse,
        EditingSessionsActiveError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/editing-sessions', method: 'get', ...variables, signal });

export const useEditingSessionsActive = <TData = EditingSessionsActiveResponse>(
    variables: EditingSessionsActiveVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            EditingSessionsActiveResponse,
            EditingSessionsActiveError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        EditingSessionsActiveResponse,
        EditingSessionsActiveError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/editing-sessions',
            operationId: 'editingSessionsActive',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchEditingSessionsActive(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type EditingSessionsForceEndPathParams = {
    /**
     * @format uuid
     */
    sessionId: string;
};

export type EditingSessionsForceEndError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type EditingSessionsForceEndVariables = {
    pathParams: EditingSessionsForceEndPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchEditingSessionsForceEnd = (
    variables: EditingSessionsForceEndVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        EditingSessionsForceEndError,
        undefined,
        {},
        {},
        EditingSessionsForceEndPathParams
    >({
        url: '/api/editing-sessions/{sessionId}',
        method: 'delete',
        ...variables,
        signal,
    });

export const useEditingSessionsForceEnd = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            EditingSessionsForceEndError,
            EditingSessionsForceEndVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        EditingSessionsForceEndError,
        EditingSessionsForceEndVariables
    >({
        mutationFn: (variables: EditingSessionsForceEndVariables) =>
            fetchEditingSessionsForceEnd({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type EditingSessionsHistoryPathParams = {
    /**
     * @format uuid
     */
    patientId: string;
};

export type EditingSessionsHistoryQueryParams = {
    /**
     * @format int32
     * @default 1
     */
    page?: number;
    /**
     * @format int32
     * @default 50
     */
    pageSize?: number;
};

export type EditingSessionsHistoryError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
>;

export type EditingSessionsHistoryVariables = {
    pathParams: EditingSessionsHistoryPathParams;
    queryParams?: EditingSessionsHistoryQueryParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchEditingSessionsHistory = (
    variables: EditingSessionsHistoryVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.EditingSessionPageDto,
        EditingSessionsHistoryError,
        undefined,
        {},
        EditingSessionsHistoryQueryParams,
        EditingSessionsHistoryPathParams
    >({
        url: '/api/patients/{patientId}/editing-sessions',
        method: 'get',
        ...variables,
        signal,
    });

export const useEditingSessionsHistory = <
    TData = Schemas.EditingSessionPageDto,
>(
    variables: EditingSessionsHistoryVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.EditingSessionPageDto,
            EditingSessionsHistoryError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.EditingSessionPageDto,
        EditingSessionsHistoryError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/patients/{patientId}/editing-sessions',
            operationId: 'editingSessionsHistory',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchEditingSessionsHistory(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type EditorsJoinPathParams = {
    /**
     * @format uuid
     */
    patientId: string;
};

export type EditorsJoinError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
>;

export type EditorsJoinVariables = {
    body?: Schemas.JoinEditingRequest;
    pathParams: EditorsJoinPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchEditorsJoin = (
    variables: EditorsJoinVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.EditorsResponse,
        EditorsJoinError,
        Schemas.JoinEditingRequest,
        {},
        {},
        EditorsJoinPathParams
    >({
        url: '/api/patients/{patientId}/editors',
        method: 'post',
        ...variables,
        signal,
    });

export const useEditorsJoin = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.EditorsResponse,
            EditorsJoinError,
            EditorsJoinVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.EditorsResponse,
        EditorsJoinError,
        EditorsJoinVariables
    >({
        mutationFn: (variables: EditorsJoinVariables) =>
            fetchEditorsJoin({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type EditorsListPathParams = {
    /**
     * @format uuid
     */
    patientId: string;
};

export type EditorsListError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type EditorsListVariables = {
    pathParams: EditorsListPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchEditorsList = (
    variables: EditorsListVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.EditorsResponse,
        EditorsListError,
        undefined,
        {},
        {},
        EditorsListPathParams
    >({
        url: '/api/patients/{patientId}/editors',
        method: 'get',
        ...variables,
        signal,
    });

export const useEditorsList = <TData = Schemas.EditorsResponse>(
    variables: EditorsListVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.EditorsResponse,
            EditorsListError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.EditorsResponse,
        EditorsListError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/patients/{patientId}/editors',
            operationId: 'editorsList',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchEditorsList({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type EditorsLeavePathParams = {
    /**
     * @format uuid
     */
    patientId: string;
    clientSessionId: string;
};

export type EditorsLeaveError = Fetcher.ErrorWrapper<undefined>;

export type EditorsLeaveVariables = {
    pathParams: EditorsLeavePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchEditorsLeave = (
    variables: EditorsLeaveVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        EditorsLeaveError,
        undefined,
        {},
        {},
        EditorsLeavePathParams
    >({
        url: '/api/patients/{patientId}/editors/{clientSessionId}',
        method: 'delete',
        ...variables,
        signal,
    });

export const useEditorsLeave = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            EditorsLeaveError,
            EditorsLeaveVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        EditorsLeaveError,
        EditorsLeaveVariables
    >({
        mutationFn: (variables: EditorsLeaveVariables) =>
            fetchEditorsLeave({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type GetHealthError = Fetcher.ErrorWrapper<undefined>;

export type GetHealthVariables = ConnectorNextContext['fetcherOptions'];

export const fetchGetHealth = (
    variables: GetHealthVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.HealthResponse,
        GetHealthError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/health', method: 'get', ...variables, signal });

export const useGetHealth = <TData = Schemas.HealthResponse>(
    variables: GetHealthVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.HealthResponse,
            GetHealthError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<Schemas.HealthResponse, GetHealthError, TData>({
        queryKey: queryKeyFn({
            path: '/api/health',
            operationId: 'getHealth',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchGetHealth({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type GetVersionError = Fetcher.ErrorWrapper<undefined>;

export type GetVersionVariables = ConnectorNextContext['fetcherOptions'];

export const fetchGetVersion = (
    variables: GetVersionVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.VersionResponse,
        GetVersionError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/version', method: 'get', ...variables, signal });

export const useGetVersion = <TData = Schemas.VersionResponse>(
    variables: GetVersionVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.VersionResponse,
            GetVersionError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<Schemas.VersionResponse, GetVersionError, TData>(
        {
            queryKey: queryKeyFn({
                path: '/api/version',
                operationId: 'getVersion',
                variables,
            }),
            queryFn: ({ signal }) =>
                fetchGetVersion({ ...fetcherOptions, ...variables }, signal),
            ...options,
            ...queryOptions,
        }
    );
};

export type ImagesGetByIdPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type ImagesGetByIdError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type ImagesGetByIdVariables = {
    pathParams: ImagesGetByIdPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchImagesGetById = (
    variables: ImagesGetByIdVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.ImageDetailResponse,
        ImagesGetByIdError,
        undefined,
        {},
        {},
        ImagesGetByIdPathParams
    >({ url: '/api/images/{id}', method: 'get', ...variables, signal });

export const useImagesGetById = <TData = Schemas.ImageDetailResponse>(
    variables: ImagesGetByIdVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.ImageDetailResponse,
            ImagesGetByIdError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.ImageDetailResponse,
        ImagesGetByIdError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/images/{id}',
            operationId: 'imagesGetById',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchImagesGetById({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type ImagesRenamePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type ImagesRenameError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type ImagesRenameVariables = {
    body?: Schemas.UpdateImageRequest;
    pathParams: ImagesRenamePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchImagesRename = (
    variables: ImagesRenameVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.ImageRenameResponse,
        ImagesRenameError,
        Schemas.UpdateImageRequest,
        {},
        {},
        ImagesRenamePathParams
    >({ url: '/api/images/{id}', method: 'patch', ...variables, signal });

export const useImagesRename = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.ImageRenameResponse,
            ImagesRenameError,
            ImagesRenameVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.ImageRenameResponse,
        ImagesRenameError,
        ImagesRenameVariables
    >({
        mutationFn: (variables: ImagesRenameVariables) =>
            fetchImagesRename({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type ImagesDeletePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type ImagesDeleteError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
>;

export type ImagesDeleteVariables = {
    pathParams: ImagesDeletePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchImagesDelete = (
    variables: ImagesDeleteVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        ImagesDeleteError,
        undefined,
        {},
        {},
        ImagesDeletePathParams
    >({ url: '/api/images/{id}', method: 'delete', ...variables, signal });

export const useImagesDelete = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            ImagesDeleteError,
            ImagesDeleteVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        ImagesDeleteError,
        ImagesDeleteVariables
    >({
        mutationFn: (variables: ImagesDeleteVariables) =>
            fetchImagesDelete({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type LocalSignInModesError = Fetcher.ErrorWrapper<undefined>;

export type LocalSignInModesVariables = ConnectorNextContext['fetcherOptions'];

export const fetchLocalSignInModes = (
    variables: LocalSignInModesVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.AuthenticationModes,
        LocalSignInModesError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/auth/modes', method: 'get', ...variables, signal });

export const useLocalSignInModes = <TData = Schemas.AuthenticationModes>(
    variables: LocalSignInModesVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.AuthenticationModes,
            LocalSignInModesError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.AuthenticationModes,
        LocalSignInModesError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/auth/modes',
            operationId: 'localSignInModes',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchLocalSignInModes({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type LocalSignInSignInError = Fetcher.ErrorWrapper<
    | {
          status: 401;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
>;

export type LocalSignInSignInVariables = {
    body?: Schemas.LocalSignInRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchLocalSignInSignIn = (
    variables: LocalSignInSignInVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        LocalSignInSignInError,
        Schemas.LocalSignInRequest,
        {},
        {},
        {}
    >({ url: '/api/auth/sign-in', method: 'post', ...variables, signal });

export const useLocalSignInSignIn = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            LocalSignInSignInError,
            LocalSignInSignInVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        LocalSignInSignInError,
        LocalSignInSignInVariables
    >({
        mutationFn: (variables: LocalSignInSignInVariables) =>
            fetchLocalSignInSignIn({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type LocalSignInSignOutLocalError = Fetcher.ErrorWrapper<undefined>;

export type LocalSignInSignOutLocalVariables =
    ConnectorNextContext['fetcherOptions'];

export const fetchLocalSignInSignOutLocal = (
    variables: LocalSignInSignOutLocalVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        LocalSignInSignOutLocalError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/auth/sign-out', method: 'post', ...variables, signal });

export const useLocalSignInSignOutLocal = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            LocalSignInSignOutLocalError,
            LocalSignInSignOutLocalVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        LocalSignInSignOutLocalError,
        LocalSignInSignOutLocalVariables
    >({
        mutationFn: (variables: LocalSignInSignOutLocalVariables) =>
            fetchLocalSignInSignOutLocal({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientCasesCreateCasePathParams = {
    /**
     * @format uuid
     */
    patientId: string;
};

export type PatientCasesCreateCaseError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientCasesCreateCaseVariables = {
    body?: Schemas.CreateCaseRequest;
    pathParams: PatientCasesCreateCasePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientCasesCreateCase = (
    variables: PatientCasesCreateCaseVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.CaseCreatedDto,
        PatientCasesCreateCaseError,
        Schemas.CreateCaseRequest,
        {},
        {},
        PatientCasesCreateCasePathParams
    >({
        url: '/api/patients/{patientId}/cases',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientCasesCreateCase = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.CaseCreatedDto,
            PatientCasesCreateCaseError,
            PatientCasesCreateCaseVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.CaseCreatedDto,
        PatientCasesCreateCaseError,
        PatientCasesCreateCaseVariables
    >({
        mutationFn: (variables: PatientCasesCreateCaseVariables) =>
            fetchPatientCasesCreateCase({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientCasesUpdateCasePathParams = {
    /**
     * @format uuid
     */
    patientId: string;
    /**
     * @format uuid
     */
    caseId: string;
};

export type PatientCasesUpdateCaseError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientCasesUpdateCaseVariables = {
    body?: Schemas.UpdateCaseRequest;
    pathParams: PatientCasesUpdateCasePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientCasesUpdateCase = (
    variables: PatientCasesUpdateCaseVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientCasesUpdateCaseError,
        Schemas.UpdateCaseRequest,
        {},
        {},
        PatientCasesUpdateCasePathParams
    >({
        url: '/api/patients/{patientId}/cases/{caseId}',
        method: 'patch',
        ...variables,
        signal,
    });

export const usePatientCasesUpdateCase = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientCasesUpdateCaseError,
            PatientCasesUpdateCaseVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientCasesUpdateCaseError,
        PatientCasesUpdateCaseVariables
    >({
        mutationFn: (variables: PatientCasesUpdateCaseVariables) =>
            fetchPatientCasesUpdateCase({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientCasesDeleteCasePathParams = {
    /**
     * @format uuid
     */
    patientId: string;
    /**
     * @format uuid
     */
    caseId: string;
};

export type PatientCasesDeleteCaseError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientCasesDeleteCaseVariables = {
    pathParams: PatientCasesDeleteCasePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientCasesDeleteCase = (
    variables: PatientCasesDeleteCaseVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientCasesDeleteCaseError,
        undefined,
        {},
        {},
        PatientCasesDeleteCasePathParams
    >({
        url: '/api/patients/{patientId}/cases/{caseId}',
        method: 'delete',
        ...variables,
        signal,
    });

export const usePatientCasesDeleteCase = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientCasesDeleteCaseError,
            PatientCasesDeleteCaseVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientCasesDeleteCaseError,
        PatientCasesDeleteCaseVariables
    >({
        mutationFn: (variables: PatientCasesDeleteCaseVariables) =>
            fetchPatientCasesDeleteCase({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientCasesChangeCaseMembersPathParams = {
    /**
     * @format uuid
     */
    patientId: string;
    /**
     * @format uuid
     */
    caseId: string;
};

export type PatientCasesChangeCaseMembersError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientCasesChangeCaseMembersVariables = {
    body?: Schemas.ChangeCaseMembersRequest;
    pathParams: PatientCasesChangeCaseMembersPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientCasesChangeCaseMembers = (
    variables: PatientCasesChangeCaseMembersVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientCasesChangeCaseMembersError,
        Schemas.ChangeCaseMembersRequest,
        {},
        {},
        PatientCasesChangeCaseMembersPathParams
    >({
        url: '/api/patients/{patientId}/cases/{caseId}/members',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientCasesChangeCaseMembers = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientCasesChangeCaseMembersError,
            PatientCasesChangeCaseMembersVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientCasesChangeCaseMembersError,
        PatientCasesChangeCaseMembersVariables
    >({
        mutationFn: (variables: PatientCasesChangeCaseMembersVariables) =>
            fetchPatientCasesChangeCaseMembers({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type PatientCasesSetCasePrimaryImagePathParams = {
    /**
     * @format uuid
     */
    patientId: string;
    /**
     * @format uuid
     */
    caseId: string;
};

export type PatientCasesSetCasePrimaryImageError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientCasesSetCasePrimaryImageVariables = {
    body?: Schemas.SetPrimaryDatasetRequest;
    pathParams: PatientCasesSetCasePrimaryImagePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientCasesSetCasePrimaryImage = (
    variables: PatientCasesSetCasePrimaryImageVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientCasesSetCasePrimaryImageError,
        Schemas.SetPrimaryDatasetRequest,
        {},
        {},
        PatientCasesSetCasePrimaryImagePathParams
    >({
        url: '/api/patients/{patientId}/cases/{caseId}/primary-image',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientCasesSetCasePrimaryImage = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientCasesSetCasePrimaryImageError,
            PatientCasesSetCasePrimaryImageVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientCasesSetCasePrimaryImageError,
        PatientCasesSetCasePrimaryImageVariables
    >({
        mutationFn: (variables: PatientCasesSetCasePrimaryImageVariables) =>
            fetchPatientCasesSetCasePrimaryImage({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type PatientCasesSetCasePrimaryStructureSetPathParams = {
    /**
     * @format uuid
     */
    patientId: string;
    /**
     * @format uuid
     */
    caseId: string;
};

export type PatientCasesSetCasePrimaryStructureSetError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientCasesSetCasePrimaryStructureSetVariables = {
    body?: Schemas.SetPrimaryDatasetRequest;
    pathParams: PatientCasesSetCasePrimaryStructureSetPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientCasesSetCasePrimaryStructureSet = (
    variables: PatientCasesSetCasePrimaryStructureSetVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientCasesSetCasePrimaryStructureSetError,
        Schemas.SetPrimaryDatasetRequest,
        {},
        {},
        PatientCasesSetCasePrimaryStructureSetPathParams
    >({
        url: '/api/patients/{patientId}/cases/{caseId}/primary-structure-set',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientCasesSetCasePrimaryStructureSet = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientCasesSetCasePrimaryStructureSetError,
            PatientCasesSetCasePrimaryStructureSetVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientCasesSetCasePrimaryStructureSetError,
        PatientCasesSetCasePrimaryStructureSetVariables
    >({
        mutationFn: (
            variables: PatientCasesSetCasePrimaryStructureSetVariables
        ) =>
            fetchPatientCasesSetCasePrimaryStructureSet({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type PatientCasesSetWorkCasePathParams = {
    /**
     * @format uuid
     */
    patientId: string;
};

export type PatientCasesSetWorkCaseError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientCasesSetWorkCaseVariables = {
    body?: Schemas.SetWorkCaseRequest;
    pathParams: PatientCasesSetWorkCasePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientCasesSetWorkCase = (
    variables: PatientCasesSetWorkCaseVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientCasesSetWorkCaseError,
        Schemas.SetWorkCaseRequest,
        {},
        {},
        PatientCasesSetWorkCasePathParams
    >({
        url: '/api/patients/{patientId}/work-case',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientCasesSetWorkCase = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientCasesSetWorkCaseError,
            PatientCasesSetWorkCaseVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientCasesSetWorkCaseError,
        PatientCasesSetWorkCaseVariables
    >({
        mutationFn: (variables: PatientCasesSetWorkCaseVariables) =>
            fetchPatientCasesSetWorkCase({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsListQueryParams = {
    /**
     * @format int32
     */
    page?: number;
    /**
     * @format int32
     */
    pageSize?: number;
    search?: string;
    status?: ('Active' | 'Archived')[];
    sort?:
        | 'Name'
        | 'CreatedAt'
        | 'LastAccessedAt'
        | 'LastActivity'
        | 'CourseStage';
    direction?: 'Ascending' | 'Descending';
    courseStage?: (
        | 'Received'
        | 'ImagePreparation'
        | 'ImageRegistration'
        | 'OarContouring'
        | 'TargetContouring'
        | 'DosePrediction'
        | 'Review'
        | 'Exported'
    )[];
    modality?: ('Unknown' | 'CT' | 'MR' | 'PET' | 'CBCT')[];
    /**
     * @format uuid
     */
    assignedToUserId?: string;
    site?: string[];
    tag?: string[];
};

export type PatientsListError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.HttpValidationProblemDetails;
}>;

export type PatientsListVariables = {
    queryParams?: PatientsListQueryParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsList = (
    variables: PatientsListVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.PatientPageDto,
        PatientsListError,
        undefined,
        {},
        PatientsListQueryParams,
        {}
    >({ url: '/api/patients', method: 'get', ...variables, signal });

export const usePatientsList = <TData = Schemas.PatientPageDto>(
    variables: PatientsListVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.PatientPageDto,
            PatientsListError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.PatientPageDto,
        PatientsListError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/patients',
            operationId: 'patientsList',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchPatientsList({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type PatientsCreateError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsCreateVariables = {
    body?: Schemas.CreatePatientRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsCreate = (
    variables: PatientsCreateVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.CreatedResourceResponse,
        PatientsCreateError,
        Schemas.CreatePatientRequest,
        {},
        {},
        {}
    >({ url: '/api/patients', method: 'post', ...variables, signal });

export const usePatientsCreate = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.CreatedResourceResponse,
            PatientsCreateError,
            PatientsCreateVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.CreatedResourceResponse,
        PatientsCreateError,
        PatientsCreateVariables
    >({
        mutationFn: (variables: PatientsCreateVariables) =>
            fetchPatientsCreate({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsCountQueryParams = {
    search?: string;
    status?: ('Active' | 'Archived')[];
    courseStage?: (
        | 'Received'
        | 'ImagePreparation'
        | 'ImageRegistration'
        | 'OarContouring'
        | 'TargetContouring'
        | 'DosePrediction'
        | 'Review'
        | 'Exported'
    )[];
    modality?: ('Unknown' | 'CT' | 'MR' | 'PET' | 'CBCT')[];
    /**
     * @format uuid
     */
    assignedToUserId?: string;
    site?: string[];
    tag?: string[];
};

export type PatientsCountError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.HttpValidationProblemDetails;
}>;

export type PatientsCountVariables = {
    queryParams?: PatientsCountQueryParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsCount = (
    variables: PatientsCountVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.PatientCountDto,
        PatientsCountError,
        undefined,
        {},
        PatientsCountQueryParams,
        {}
    >({ url: '/api/patients/count', method: 'get', ...variables, signal });

export const usePatientsCount = <TData = Schemas.PatientCountDto>(
    variables: PatientsCountVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.PatientCountDto,
            PatientsCountError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.PatientCountDto,
        PatientsCountError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/patients/count',
            operationId: 'patientsCount',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchPatientsCount({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type PatientsGetByIdPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsGetByIdError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type PatientsGetByIdVariables = {
    pathParams: PatientsGetByIdPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsGetById = (
    variables: PatientsGetByIdVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.PatientDetailDto,
        PatientsGetByIdError,
        undefined,
        {},
        {},
        PatientsGetByIdPathParams
    >({ url: '/api/patients/{id}', method: 'get', ...variables, signal });

export const usePatientsGetById = <TData = Schemas.PatientDetailDto>(
    variables: PatientsGetByIdVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.PatientDetailDto,
            PatientsGetByIdError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.PatientDetailDto,
        PatientsGetByIdError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/patients/{id}',
            operationId: 'patientsGetById',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchPatientsGetById({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type PatientsDeletePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsDeleteError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsDeleteVariables = {
    pathParams: PatientsDeletePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsDelete = (
    variables: PatientsDeleteVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsDeleteError,
        undefined,
        {},
        {},
        PatientsDeletePathParams
    >({ url: '/api/patients/{id}', method: 'delete', ...variables, signal });

export const usePatientsDelete = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsDeleteError,
            PatientsDeleteVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsDeleteError,
        PatientsDeleteVariables
    >({
        mutationFn: (variables: PatientsDeleteVariables) =>
            fetchPatientsDelete({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsGetRetrievalsPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsGetRetrievalsError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type PatientsGetRetrievalsResponse = Schemas.PatientRetrievalDto[];

export type PatientsGetRetrievalsVariables = {
    pathParams: PatientsGetRetrievalsPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsGetRetrievals = (
    variables: PatientsGetRetrievalsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        PatientsGetRetrievalsResponse,
        PatientsGetRetrievalsError,
        undefined,
        {},
        {},
        PatientsGetRetrievalsPathParams
    >({
        url: '/api/patients/{id}/retrievals',
        method: 'get',
        ...variables,
        signal,
    });

export const usePatientsGetRetrievals = <TData = PatientsGetRetrievalsResponse>(
    variables: PatientsGetRetrievalsVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            PatientsGetRetrievalsResponse,
            PatientsGetRetrievalsError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        PatientsGetRetrievalsResponse,
        PatientsGetRetrievalsError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/patients/{id}/retrievals',
            operationId: 'patientsGetRetrievals',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchPatientsGetRetrievals(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type PatientsResolveError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.HttpValidationProblemDetails;
}>;

export type PatientsResolveVariables = {
    body?: Schemas.ResolvePatientRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsResolve = (
    variables: PatientsResolveVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.PatientResolutionDto,
        PatientsResolveError,
        Schemas.ResolvePatientRequest,
        {},
        {},
        {}
    >({ url: '/api/patients/resolve', method: 'post', ...variables, signal });

export const usePatientsResolve = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.PatientResolutionDto,
            PatientsResolveError,
            PatientsResolveVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.PatientResolutionDto,
        PatientsResolveError,
        PatientsResolveVariables
    >({
        mutationFn: (variables: PatientsResolveVariables) =>
            fetchPatientsResolve({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsUpdateClinicalContextPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsUpdateClinicalContextError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsUpdateClinicalContextVariables = {
    body?: Schemas.UpdateClinicalContextRequest;
    pathParams: PatientsUpdateClinicalContextPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsUpdateClinicalContext = (
    variables: PatientsUpdateClinicalContextVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsUpdateClinicalContextError,
        Schemas.UpdateClinicalContextRequest,
        {},
        {},
        PatientsUpdateClinicalContextPathParams
    >({
        url: '/api/patients/{id}/clinical-context',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientsUpdateClinicalContext = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsUpdateClinicalContextError,
            PatientsUpdateClinicalContextVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsUpdateClinicalContextError,
        PatientsUpdateClinicalContextVariables
    >({
        mutationFn: (variables: PatientsUpdateClinicalContextVariables) =>
            fetchPatientsUpdateClinicalContext({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type PatientsArchivePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsArchiveError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsArchiveVariables = {
    pathParams: PatientsArchivePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsArchive = (
    variables: PatientsArchiveVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsArchiveError,
        undefined,
        {},
        {},
        PatientsArchivePathParams
    >({
        url: '/api/patients/{id}/archive',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientsArchive = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsArchiveError,
            PatientsArchiveVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsArchiveError,
        PatientsArchiveVariables
    >({
        mutationFn: (variables: PatientsArchiveVariables) =>
            fetchPatientsArchive({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsReactivatePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsReactivateError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsReactivateVariables = {
    pathParams: PatientsReactivatePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsReactivate = (
    variables: PatientsReactivateVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsReactivateError,
        undefined,
        {},
        {},
        PatientsReactivatePathParams
    >({
        url: '/api/patients/{id}/reactivate',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientsReactivate = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsReactivateError,
            PatientsReactivateVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsReactivateError,
        PatientsReactivateVariables
    >({
        mutationFn: (variables: PatientsReactivateVariables) =>
            fetchPatientsReactivate({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsSetIntakePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsSetIntakeError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsSetIntakeVariables = {
    body?: Schemas.IntakeRequest;
    pathParams: PatientsSetIntakePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsSetIntake = (
    variables: PatientsSetIntakeVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsSetIntakeError,
        Schemas.IntakeRequest,
        {},
        {},
        PatientsSetIntakePathParams
    >({
        url: '/api/patients/{id}/intake',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientsSetIntake = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsSetIntakeError,
            PatientsSetIntakeVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsSetIntakeError,
        PatientsSetIntakeVariables
    >({
        mutationFn: (variables: PatientsSetIntakeVariables) =>
            fetchPatientsSetIntake({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsSetTagsPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsSetTagsError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsSetTagsVariables = {
    body?: Schemas.SetTagsRequest;
    pathParams: PatientsSetTagsPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsSetTags = (
    variables: PatientsSetTagsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsSetTagsError,
        Schemas.SetTagsRequest,
        {},
        {},
        PatientsSetTagsPathParams
    >({ url: '/api/patients/{id}/tags', method: 'post', ...variables, signal });

export const usePatientsSetTags = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsSetTagsError,
            PatientsSetTagsVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsSetTagsError,
        PatientsSetTagsVariables
    >({
        mutationFn: (variables: PatientsSetTagsVariables) =>
            fetchPatientsSetTags({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsReleasePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsReleaseError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsReleaseVariables = {
    pathParams: PatientsReleasePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsRelease = (
    variables: PatientsReleaseVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsReleaseError,
        undefined,
        {},
        {},
        PatientsReleasePathParams
    >({
        url: '/api/patients/{id}/release',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientsRelease = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsReleaseError,
            PatientsReleaseVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsReleaseError,
        PatientsReleaseVariables
    >({
        mutationFn: (variables: PatientsReleaseVariables) =>
            fetchPatientsRelease({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsAssignPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsAssignError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsAssignVariables = {
    body: Schemas.AssignPatientRequest;
    pathParams: PatientsAssignPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsAssign = (
    variables: PatientsAssignVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsAssignError,
        Schemas.AssignPatientRequest,
        {},
        {},
        PatientsAssignPathParams
    >({
        url: '/api/patients/{id}/assignment',
        method: 'put',
        ...variables,
        signal,
    });

export const usePatientsAssign = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsAssignError,
            PatientsAssignVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsAssignError,
        PatientsAssignVariables
    >({
        mutationFn: (variables: PatientsAssignVariables) =>
            fetchPatientsAssign({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsSetCourseStagePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsSetCourseStageError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsSetCourseStageVariables = {
    body?: Schemas.SetCourseStageRequest;
    pathParams: PatientsSetCourseStagePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsSetCourseStage = (
    variables: PatientsSetCourseStageVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsSetCourseStageError,
        Schemas.SetCourseStageRequest,
        {},
        {},
        PatientsSetCourseStagePathParams
    >({
        url: '/api/patients/{id}/course-stage',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientsSetCourseStage = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsSetCourseStageError,
            PatientsSetCourseStageVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsSetCourseStageError,
        PatientsSetCourseStageVariables
    >({
        mutationFn: (variables: PatientsSetCourseStageVariables) =>
            fetchPatientsSetCourseStage({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsSetPrimaryImagePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsSetPrimaryImageError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsSetPrimaryImageVariables = {
    body?: Schemas.SetPrimaryDatasetRequest;
    pathParams: PatientsSetPrimaryImagePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsSetPrimaryImage = (
    variables: PatientsSetPrimaryImageVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsSetPrimaryImageError,
        Schemas.SetPrimaryDatasetRequest,
        {},
        {},
        PatientsSetPrimaryImagePathParams
    >({
        url: '/api/patients/{id}/primary-image',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientsSetPrimaryImage = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsSetPrimaryImageError,
            PatientsSetPrimaryImageVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsSetPrimaryImageError,
        PatientsSetPrimaryImageVariables
    >({
        mutationFn: (variables: PatientsSetPrimaryImageVariables) =>
            fetchPatientsSetPrimaryImage({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type PatientsSetPrimaryStructureSetPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type PatientsSetPrimaryStructureSetError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PatientsSetPrimaryStructureSetVariables = {
    body?: Schemas.SetPrimaryDatasetRequest;
    pathParams: PatientsSetPrimaryStructureSetPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPatientsSetPrimaryStructureSet = (
    variables: PatientsSetPrimaryStructureSetVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        PatientsSetPrimaryStructureSetError,
        Schemas.SetPrimaryDatasetRequest,
        {},
        {},
        PatientsSetPrimaryStructureSetPathParams
    >({
        url: '/api/patients/{id}/primary-structure-set',
        method: 'post',
        ...variables,
        signal,
    });

export const usePatientsSetPrimaryStructureSet = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            PatientsSetPrimaryStructureSetError,
            PatientsSetPrimaryStructureSetVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        PatientsSetPrimaryStructureSetError,
        PatientsSetPrimaryStructureSetVariables
    >({
        mutationFn: (variables: PatientsSetPrimaryStructureSetVariables) =>
            fetchPatientsSetPrimaryStructureSet({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type PreferencesReadError = Fetcher.ErrorWrapper<undefined>;

export type PreferencesReadVariables = ConnectorNextContext['fetcherOptions'];

export const fetchPreferencesRead = (
    variables: PreferencesReadVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.UserPreferencesDto,
        PreferencesReadError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/preferences/me', method: 'get', ...variables, signal });

export const usePreferencesRead = <TData = Schemas.UserPreferencesDto>(
    variables: PreferencesReadVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.UserPreferencesDto,
            PreferencesReadError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.UserPreferencesDto,
        PreferencesReadError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/preferences/me',
            operationId: 'preferencesRead',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchPreferencesRead({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type PreferencesSaveError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type PreferencesSaveVariables = {
    body?: Schemas.SaveUserPreferencesRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchPreferencesSave = (
    variables: PreferencesSaveVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.UserPreferencesDto,
        PreferencesSaveError,
        Schemas.SaveUserPreferencesRequest,
        {},
        {},
        {}
    >({ url: '/api/preferences/me', method: 'put', ...variables, signal });

export const usePreferencesSave = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.UserPreferencesDto,
            PreferencesSaveError,
            PreferencesSaveVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.UserPreferencesDto,
        PreferencesSaveError,
        PreferencesSaveVariables
    >({
        mutationFn: (variables: PreferencesSaveVariables) =>
            fetchPreferencesSave({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type RegistrationsCreateError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
>;

export type RegistrationsCreateVariables = {
    body?: Schemas.CreateRegistrationRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchRegistrationsCreate = (
    variables: RegistrationsCreateVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.CreateRegistrationResponse,
        RegistrationsCreateError,
        Schemas.CreateRegistrationRequest,
        {},
        {},
        {}
    >({ url: '/api/registrations', method: 'post', ...variables, signal });

export const useRegistrationsCreate = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.CreateRegistrationResponse,
            RegistrationsCreateError,
            RegistrationsCreateVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.CreateRegistrationResponse,
        RegistrationsCreateError,
        RegistrationsCreateVariables
    >({
        mutationFn: (variables: RegistrationsCreateVariables) =>
            fetchRegistrationsCreate({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type RegistrationsGetByIdPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type RegistrationsGetByIdError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type RegistrationsGetByIdVariables = {
    pathParams: RegistrationsGetByIdPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchRegistrationsGetById = (
    variables: RegistrationsGetByIdVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.RegistrationDetailResponse,
        RegistrationsGetByIdError,
        undefined,
        {},
        {},
        RegistrationsGetByIdPathParams
    >({ url: '/api/registrations/{id}', method: 'get', ...variables, signal });

export const useRegistrationsGetById = <
    TData = Schemas.RegistrationDetailResponse,
>(
    variables: RegistrationsGetByIdVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.RegistrationDetailResponse,
            RegistrationsGetByIdError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.RegistrationDetailResponse,
        RegistrationsGetByIdError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/registrations/{id}',
            operationId: 'registrationsGetById',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchRegistrationsGetById(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type RegistrationsRenamePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type RegistrationsRenameError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type RegistrationsRenameVariables = {
    body?: Schemas.UpdateRegistrationRequest;
    pathParams: RegistrationsRenamePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchRegistrationsRename = (
    variables: RegistrationsRenameVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.RegistrationRenameResponse,
        RegistrationsRenameError,
        Schemas.UpdateRegistrationRequest,
        {},
        {},
        RegistrationsRenamePathParams
    >({
        url: '/api/registrations/{id}',
        method: 'patch',
        ...variables,
        signal,
    });

export const useRegistrationsRename = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.RegistrationRenameResponse,
            RegistrationsRenameError,
            RegistrationsRenameVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.RegistrationRenameResponse,
        RegistrationsRenameError,
        RegistrationsRenameVariables
    >({
        mutationFn: (variables: RegistrationsRenameVariables) =>
            fetchRegistrationsRename({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type RegistrationsDeletePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type RegistrationsDeleteError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
>;

export type RegistrationsDeleteVariables = {
    pathParams: RegistrationsDeletePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchRegistrationsDelete = (
    variables: RegistrationsDeleteVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        RegistrationsDeleteError,
        undefined,
        {},
        {},
        RegistrationsDeletePathParams
    >({
        url: '/api/registrations/{id}',
        method: 'delete',
        ...variables,
        signal,
    });

export const useRegistrationsDelete = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            RegistrationsDeleteError,
            RegistrationsDeleteVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        RegistrationsDeleteError,
        RegistrationsDeleteVariables
    >({
        mutationFn: (variables: RegistrationsDeleteVariables) =>
            fetchRegistrationsDelete({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type RegistrationsUpdateMatrixPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type RegistrationsUpdateMatrixError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type RegistrationsUpdateMatrixVariables = {
    body?: Schemas.UpdateRegistrationMatrixRequest;
    pathParams: RegistrationsUpdateMatrixPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchRegistrationsUpdateMatrix = (
    variables: RegistrationsUpdateMatrixVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.RegistrationDetailResponse,
        RegistrationsUpdateMatrixError,
        Schemas.UpdateRegistrationMatrixRequest,
        {},
        {},
        RegistrationsUpdateMatrixPathParams
    >({
        url: '/api/registrations/{id}/matrix',
        method: 'put',
        ...variables,
        signal,
    });

export const useRegistrationsUpdateMatrix = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.RegistrationDetailResponse,
            RegistrationsUpdateMatrixError,
            RegistrationsUpdateMatrixVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.RegistrationDetailResponse,
        RegistrationsUpdateMatrixError,
        RegistrationsUpdateMatrixVariables
    >({
        mutationFn: (variables: RegistrationsUpdateMatrixVariables) =>
            fetchRegistrationsUpdateMatrix({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type RegistrationsSetApprovalPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type RegistrationsSetApprovalError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type RegistrationsSetApprovalVariables = {
    body?: Schemas.SetApprovalRequest;
    pathParams: RegistrationsSetApprovalPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchRegistrationsSetApproval = (
    variables: RegistrationsSetApprovalVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.RegistrationApprovalResponse,
        RegistrationsSetApprovalError,
        Schemas.SetApprovalRequest,
        {},
        {},
        RegistrationsSetApprovalPathParams
    >({
        url: '/api/registrations/{id}/approval',
        method: 'post',
        ...variables,
        signal,
    });

export const useRegistrationsSetApproval = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.RegistrationApprovalResponse,
            RegistrationsSetApprovalError,
            RegistrationsSetApprovalVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.RegistrationApprovalResponse,
        RegistrationsSetApprovalError,
        RegistrationsSetApprovalVariables
    >({
        mutationFn: (variables: RegistrationsSetApprovalVariables) =>
            fetchRegistrationsSetApproval({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type SessionsCreateError = Fetcher.ErrorWrapper<{
    status: 400;
    payload: Schemas.HttpValidationProblemDetails;
}>;

export type SessionsCreateVariables = {
    body?: Schemas.CreateSessionRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchSessionsCreate = (
    variables: SessionsCreateVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.CreatedResourceResponse,
        SessionsCreateError,
        Schemas.CreateSessionRequest,
        {},
        {},
        {}
    >({ url: '/api/sessions', method: 'post', ...variables, signal });

export const useSessionsCreate = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.CreatedResourceResponse,
            SessionsCreateError,
            SessionsCreateVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.CreatedResourceResponse,
        SessionsCreateError,
        SessionsCreateVariables
    >({
        mutationFn: (variables: SessionsCreateVariables) =>
            fetchSessionsCreate({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type SessionsGetByIdPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type SessionsGetByIdError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type SessionsGetByIdVariables = {
    pathParams: SessionsGetByIdPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchSessionsGetById = (
    variables: SessionsGetByIdVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.SessionResponse,
        SessionsGetByIdError,
        undefined,
        {},
        {},
        SessionsGetByIdPathParams
    >({ url: '/api/sessions/{id}', method: 'get', ...variables, signal });

export const useSessionsGetById = <TData = Schemas.SessionResponse>(
    variables: SessionsGetByIdVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.SessionResponse,
            SessionsGetByIdError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.SessionResponse,
        SessionsGetByIdError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/sessions/{id}',
            operationId: 'sessionsGetById',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchSessionsGetById({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type StructureSetsGetByIdPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type StructureSetsGetByIdError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type StructureSetsGetByIdVariables = {
    pathParams: StructureSetsGetByIdPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsGetById = (
    variables: StructureSetsGetByIdVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.StructureSetDetailResponse,
        StructureSetsGetByIdError,
        undefined,
        {},
        {},
        StructureSetsGetByIdPathParams
    >({ url: '/api/structure-sets/{id}', method: 'get', ...variables, signal });

export const useStructureSetsGetById = <
    TData = Schemas.StructureSetDetailResponse,
>(
    variables: StructureSetsGetByIdVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.StructureSetDetailResponse,
            StructureSetsGetByIdError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.StructureSetDetailResponse,
        StructureSetsGetByIdError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/structure-sets/{id}',
            operationId: 'structureSetsGetById',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchStructureSetsGetById(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type StructureSetsUpdateMetadataPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type StructureSetsUpdateMetadataError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type StructureSetsUpdateMetadataVariables = {
    body?: Schemas.UpdateStructureSetRequest;
    pathParams: StructureSetsUpdateMetadataPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsUpdateMetadata = (
    variables: StructureSetsUpdateMetadataVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.StructureSetDetailResponse,
        StructureSetsUpdateMetadataError,
        Schemas.UpdateStructureSetRequest,
        {},
        {},
        StructureSetsUpdateMetadataPathParams
    >({
        url: '/api/structure-sets/{id}',
        method: 'patch',
        ...variables,
        signal,
    });

export const useStructureSetsUpdateMetadata = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.StructureSetDetailResponse,
            StructureSetsUpdateMetadataError,
            StructureSetsUpdateMetadataVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.StructureSetDetailResponse,
        StructureSetsUpdateMetadataError,
        StructureSetsUpdateMetadataVariables
    >({
        mutationFn: (variables: StructureSetsUpdateMetadataVariables) =>
            fetchStructureSetsUpdateMetadata({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type StructureSetsDeletePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type StructureSetsDeleteError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
>;

export type StructureSetsDeleteVariables = {
    pathParams: StructureSetsDeletePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsDelete = (
    variables: StructureSetsDeleteVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        StructureSetsDeleteError,
        undefined,
        {},
        {},
        StructureSetsDeletePathParams
    >({
        url: '/api/structure-sets/{id}',
        method: 'delete',
        ...variables,
        signal,
    });

export const useStructureSetsDelete = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            undefined,
            StructureSetsDeleteError,
            StructureSetsDeleteVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        undefined,
        StructureSetsDeleteError,
        StructureSetsDeleteVariables
    >({
        mutationFn: (variables: StructureSetsDeleteVariables) =>
            fetchStructureSetsDelete({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type StructureSetsGetHistoryPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type StructureSetsGetHistoryError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type StructureSetsGetHistoryVariables = {
    pathParams: StructureSetsGetHistoryPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsGetHistory = (
    variables: StructureSetsGetHistoryVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.DatasetHistoryResponse,
        StructureSetsGetHistoryError,
        undefined,
        {},
        {},
        StructureSetsGetHistoryPathParams
    >({
        url: '/api/structure-sets/{id}/history',
        method: 'get',
        ...variables,
        signal,
    });

export const useStructureSetsGetHistory = <
    TData = Schemas.DatasetHistoryResponse,
>(
    variables: StructureSetsGetHistoryVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            Schemas.DatasetHistoryResponse,
            StructureSetsGetHistoryError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        Schemas.DatasetHistoryResponse,
        StructureSetsGetHistoryError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/structure-sets/{id}/history',
            operationId: 'structureSetsGetHistory',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchStructureSetsGetHistory(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type StructureSetsGetModelResultPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type StructureSetsGetModelResultError = Fetcher.ErrorWrapper<undefined>;

export type StructureSetsGetModelResultVariables = {
    pathParams: StructureSetsGetModelResultPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsGetModelResult = (
    variables: StructureSetsGetModelResultVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        StructureSetsGetModelResultError,
        undefined,
        {},
        {},
        StructureSetsGetModelResultPathParams
    >({
        url: '/api/structure-sets/{id}/model-result',
        method: 'get',
        ...variables,
        signal,
    });

export const useStructureSetsGetModelResult = <TData = undefined>(
    variables: StructureSetsGetModelResultVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            undefined,
            StructureSetsGetModelResultError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<
        undefined,
        StructureSetsGetModelResultError,
        TData
    >({
        queryKey: queryKeyFn({
            path: '/api/structure-sets/{id}/model-result',
            operationId: 'structureSetsGetModelResult',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchStructureSetsGetModelResult(
                { ...fetcherOptions, ...variables },
                signal
            ),
        ...options,
        ...queryOptions,
    });
};

export type StructureSetsCreateError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
>;

export type StructureSetsCreateVariables = {
    body?: Schemas.CreateStructureSetRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsCreate = (
    variables: StructureSetsCreateVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.StructureSetDetailResponse,
        StructureSetsCreateError,
        Schemas.CreateStructureSetRequest,
        {},
        {},
        {}
    >({ url: '/api/structure-sets', method: 'post', ...variables, signal });

export const useStructureSetsCreate = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.StructureSetDetailResponse,
            StructureSetsCreateError,
            StructureSetsCreateVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.StructureSetDetailResponse,
        StructureSetsCreateError,
        StructureSetsCreateVariables
    >({
        mutationFn: (variables: StructureSetsCreateVariables) =>
            fetchStructureSetsCreate({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type StructureSetsDuplicatePathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type StructureSetsDuplicateError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
>;

export type StructureSetsDuplicateVariables = {
    body?: Schemas.DuplicateStructureSetRequest;
    pathParams: StructureSetsDuplicatePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsDuplicate = (
    variables: StructureSetsDuplicateVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.StructureSetDetailResponse,
        StructureSetsDuplicateError,
        Schemas.DuplicateStructureSetRequest,
        {},
        {},
        StructureSetsDuplicatePathParams
    >({
        url: '/api/structure-sets/{id}/duplicate',
        method: 'post',
        ...variables,
        signal,
    });

export const useStructureSetsDuplicate = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.StructureSetDetailResponse,
            StructureSetsDuplicateError,
            StructureSetsDuplicateVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.StructureSetDetailResponse,
        StructureSetsDuplicateError,
        StructureSetsDuplicateVariables
    >({
        mutationFn: (variables: StructureSetsDuplicateVariables) =>
            fetchStructureSetsDuplicate({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type StructureSetsReplaceContentPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type StructureSetsReplaceContentError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type StructureSetsReplaceContentVariables = {
    pathParams: StructureSetsReplaceContentPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsReplaceContent = (
    variables: StructureSetsReplaceContentVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.StructureSetDetailResponse,
        StructureSetsReplaceContentError,
        undefined,
        {},
        {},
        StructureSetsReplaceContentPathParams
    >({
        url: '/api/structure-sets/{id}/content',
        method: 'put',
        ...variables,
        signal,
    });

export const useStructureSetsReplaceContent = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.StructureSetDetailResponse,
            StructureSetsReplaceContentError,
            StructureSetsReplaceContentVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.StructureSetDetailResponse,
        StructureSetsReplaceContentError,
        StructureSetsReplaceContentVariables
    >({
        mutationFn: (variables: StructureSetsReplaceContentVariables) =>
            fetchStructureSetsReplaceContent({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type StructureSetsSetApprovalPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type StructureSetsSetApprovalError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.HttpValidationProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type StructureSetsSetApprovalVariables = {
    body?: Schemas.SetApprovalRequest;
    pathParams: StructureSetsSetApprovalPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsSetApproval = (
    variables: StructureSetsSetApprovalVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.StructureSetDetailResponse,
        StructureSetsSetApprovalError,
        Schemas.SetApprovalRequest,
        {},
        {},
        StructureSetsSetApprovalPathParams
    >({
        url: '/api/structure-sets/{id}/approval',
        method: 'post',
        ...variables,
        signal,
    });

export const useStructureSetsSetApproval = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.StructureSetDetailResponse,
            StructureSetsSetApprovalError,
            StructureSetsSetApprovalVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.StructureSetDetailResponse,
        StructureSetsSetApprovalError,
        StructureSetsSetApprovalVariables
    >({
        mutationFn: (variables: StructureSetsSetApprovalVariables) =>
            fetchStructureSetsSetApproval({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type StructureSetsUpdateStructurePathParams = {
    /**
     * @format uuid
     */
    id: string;
    /**
     * @format uuid
     */
    roiUid: string;
};

export type StructureSetsUpdateStructureError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type StructureSetsUpdateStructureVariables = {
    body?: Schemas.UpdateStructureRequest;
    pathParams: StructureSetsUpdateStructurePathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsUpdateStructure = (
    variables: StructureSetsUpdateStructureVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.StructureResponse,
        StructureSetsUpdateStructureError,
        Schemas.UpdateStructureRequest,
        {},
        {},
        StructureSetsUpdateStructurePathParams
    >({
        url: '/api/structure-sets/{id}/structures/{roiUid}',
        method: 'patch',
        ...variables,
        signal,
    });

export const useStructureSetsUpdateStructure = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.StructureResponse,
            StructureSetsUpdateStructureError,
            StructureSetsUpdateStructureVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.StructureResponse,
        StructureSetsUpdateStructureError,
        StructureSetsUpdateStructureVariables
    >({
        mutationFn: (variables: StructureSetsUpdateStructureVariables) =>
            fetchStructureSetsUpdateStructure({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type StructureSetsReplaceStructureReviewsPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type StructureSetsReplaceStructureReviewsError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
    | {
          status: 428;
          payload: Schemas.ProblemDetails;
      }
>;

export type StructureSetsReplaceStructureReviewsVariables = {
    body?: Schemas.StructureReviewsRequest;
    pathParams: StructureSetsReplaceStructureReviewsPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchStructureSetsReplaceStructureReviews = (
    variables: StructureSetsReplaceStructureReviewsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.StructureSetDetailResponse,
        StructureSetsReplaceStructureReviewsError,
        Schemas.StructureReviewsRequest,
        {},
        {},
        StructureSetsReplaceStructureReviewsPathParams
    >({
        url: '/api/structure-sets/{id}/structure-reviews',
        method: 'put',
        ...variables,
        signal,
    });

export const useStructureSetsReplaceStructureReviews = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.StructureSetDetailResponse,
            StructureSetsReplaceStructureReviewsError,
            StructureSetsReplaceStructureReviewsVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.StructureSetDetailResponse,
        StructureSetsReplaceStructureReviewsError,
        StructureSetsReplaceStructureReviewsVariables
    >({
        mutationFn: (
            variables: StructureSetsReplaceStructureReviewsVariables
        ) =>
            fetchStructureSetsReplaceStructureReviews({
                ...fetcherOptions,
                ...variables,
            }),
        ...options,
    });
};

export type TasksDataError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type TasksDataVariables = {
    body?: Schemas.DataTaskRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksData = (
    variables: TasksDataVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TaskView,
        TasksDataError,
        Schemas.DataTaskRequest,
        {},
        {},
        {}
    >({ url: '/api/tasks/data', method: 'post', ...variables, signal });

export const useTasksData = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.TaskView,
            TasksDataError,
            TasksDataVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.TaskView,
        TasksDataError,
        TasksDataVariables
    >({
        mutationFn: (variables: TasksDataVariables) =>
            fetchTasksData({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type TasksSegmentationError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type TasksSegmentationVariables = {
    body: Schemas.SegmentationTaskRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksSegmentation = (
    variables: TasksSegmentationVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TaskView,
        TasksSegmentationError,
        Schemas.SegmentationTaskRequest,
        {},
        {},
        {}
    >({ url: '/api/tasks/segmentation', method: 'post', ...variables, signal });

export const useTasksSegmentation = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.TaskView,
            TasksSegmentationError,
            TasksSegmentationVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.TaskView,
        TasksSegmentationError,
        TasksSegmentationVariables
    >({
        mutationFn: (variables: TasksSegmentationVariables) =>
            fetchTasksSegmentation({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type TasksDoseError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type TasksDoseVariables = {
    body: Schemas.DoseTaskRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksDose = (
    variables: TasksDoseVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TaskView,
        TasksDoseError,
        Schemas.DoseTaskRequest,
        {},
        {},
        {}
    >({ url: '/api/tasks/dose', method: 'post', ...variables, signal });

export const useTasksDose = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.TaskView,
            TasksDoseError,
            TasksDoseVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.TaskView,
        TasksDoseError,
        TasksDoseVariables
    >({
        mutationFn: (variables: TasksDoseVariables) =>
            fetchTasksDose({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type TasksImageProcessingError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type TasksImageProcessingVariables = {
    body?: Schemas.ImageProcessingTaskRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksImageProcessing = (
    variables: TasksImageProcessingVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TaskView,
        TasksImageProcessingError,
        Schemas.ImageProcessingTaskRequest,
        {},
        {},
        {}
    >({
        url: '/api/tasks/imageprocessing',
        method: 'post',
        ...variables,
        signal,
    });

export const useTasksImageProcessing = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.TaskView,
            TasksImageProcessingError,
            TasksImageProcessingVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.TaskView,
        TasksImageProcessingError,
        TasksImageProcessingVariables
    >({
        mutationFn: (variables: TasksImageProcessingVariables) =>
            fetchTasksImageProcessing({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type TasksRegistrationError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type TasksRegistrationVariables = {
    body: Schemas.RegistrationTaskRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksRegistration = (
    variables: TasksRegistrationVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TaskView,
        TasksRegistrationError,
        Schemas.RegistrationTaskRequest,
        {},
        {},
        {}
    >({ url: '/api/tasks/registration', method: 'post', ...variables, signal });

export const useTasksRegistration = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.TaskView,
            TasksRegistrationError,
            TasksRegistrationVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.TaskView,
        TasksRegistrationError,
        TasksRegistrationVariables
    >({
        mutationFn: (variables: TasksRegistrationVariables) =>
            fetchTasksRegistration({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type TasksCompositeCbctError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type TasksCompositeCbctVariables = {
    body: Schemas.CompositeCbctTaskRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksCompositeCbct = (
    variables: TasksCompositeCbctVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TaskView,
        TasksCompositeCbctError,
        Schemas.CompositeCbctTaskRequest,
        {},
        {},
        {}
    >({
        url: '/api/tasks/composite-cbct',
        method: 'post',
        ...variables,
        signal,
    });

export const useTasksCompositeCbct = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.TaskView,
            TasksCompositeCbctError,
            TasksCompositeCbctVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.TaskView,
        TasksCompositeCbctError,
        TasksCompositeCbctVariables
    >({
        mutationFn: (variables: TasksCompositeCbctVariables) =>
            fetchTasksCompositeCbct({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type TasksTranslationError = Fetcher.ErrorWrapper<
    | {
          status: 400;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
>;

export type TasksTranslationVariables = {
    body: Schemas.TranslationTaskRequest;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksTranslation = (
    variables: TasksTranslationVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TaskView,
        TasksTranslationError,
        Schemas.TranslationTaskRequest,
        {},
        {},
        {}
    >({ url: '/api/tasks/translation', method: 'post', ...variables, signal });

export const useTasksTranslation = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.TaskView,
            TasksTranslationError,
            TasksTranslationVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.TaskView,
        TasksTranslationError,
        TasksTranslationVariables
    >({
        mutationFn: (variables: TasksTranslationVariables) =>
            fetchTasksTranslation({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type TasksListError = Fetcher.ErrorWrapper<undefined>;

export type TasksListResponse = Schemas.TaskView[];

export type TasksListVariables = ConnectorNextContext['fetcherOptions'];

export const fetchTasksList = (
    variables: TasksListVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        TasksListResponse,
        TasksListError,
        undefined,
        {},
        {},
        {}
    >({ url: '/api/tasks', method: 'get', ...variables, signal });

export const useTasksList = <TData = TasksListResponse>(
    variables: TasksListVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<TasksListResponse, TasksListError, TData>,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<TasksListResponse, TasksListError, TData>({
        queryKey: queryKeyFn({
            path: '/api/tasks',
            operationId: 'tasksList',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchTasksList({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type TasksGetByIdPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type TasksGetByIdError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type TasksGetByIdVariables = {
    pathParams: TasksGetByIdPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksGetById = (
    variables: TasksGetByIdVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TaskView,
        TasksGetByIdError,
        undefined,
        {},
        {},
        TasksGetByIdPathParams
    >({ url: '/api/tasks/{id}', method: 'get', ...variables, signal });

export const useTasksGetById = <TData = Schemas.TaskView>(
    variables: TasksGetByIdVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<Schemas.TaskView, TasksGetByIdError, TData>,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<Schemas.TaskView, TasksGetByIdError, TData>({
        queryKey: queryKeyFn({
            path: '/api/tasks/{id}',
            operationId: 'tasksGetById',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchTasksGetById({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type TasksCancelPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type TasksCancelError = Fetcher.ErrorWrapper<
    | {
          status: 403;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 404;
          payload: Schemas.ProblemDetails;
      }
    | {
          status: 409;
          payload: Schemas.ProblemDetails & {
              /**
               * Present only on an optimistic-concurrency conflict: the resource's current version token to retry the request with. Absent on an approval-lock conflict.
               */
              currentVersion?: string | null;
          };
      }
>;

export type TasksCancelVariables = {
    pathParams: TasksCancelPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksCancel = (
    variables: TasksCancelVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        Schemas.TaskView,
        TasksCancelError,
        undefined,
        {},
        {},
        TasksCancelPathParams
    >({ url: '/api/tasks/{id}', method: 'delete', ...variables, signal });

export const useTasksCancel = (
    options?: Omit<
        reactQuery.UseMutationOptions<
            Schemas.TaskView,
            TasksCancelError,
            TasksCancelVariables
        >,
        'mutationFn'
    >
) => {
    const { fetcherOptions } = useConnectorNextContext();
    return reactQuery.useMutation<
        Schemas.TaskView,
        TasksCancelError,
        TasksCancelVariables
    >({
        mutationFn: (variables: TasksCancelVariables) =>
            fetchTasksCancel({ ...fetcherOptions, ...variables }),
        ...options,
    });
};

export type TasksResultsPathParams = {
    /**
     * @format uuid
     */
    id: string;
};

export type TasksResultsError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type TasksResultsResponse = string[];

export type TasksResultsVariables = {
    pathParams: TasksResultsPathParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksResults = (
    variables: TasksResultsVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        TasksResultsResponse,
        TasksResultsError,
        undefined,
        {},
        {},
        TasksResultsPathParams
    >({ url: '/api/tasks/{id}/results', method: 'get', ...variables, signal });

export const useTasksResults = <TData = TasksResultsResponse>(
    variables: TasksResultsVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<
            TasksResultsResponse,
            TasksResultsError,
            TData
        >,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<TasksResultsResponse, TasksResultsError, TData>({
        queryKey: queryKeyFn({
            path: '/api/tasks/{id}/results',
            operationId: 'tasksResults',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchTasksResults({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type TasksResultPathParams = {
    /**
     * @format uuid
     */
    id: string;
    resultPath: string;
};

export type TasksResultQueryParams = {
    debug?: boolean;
};

export type TasksResultError = Fetcher.ErrorWrapper<{
    status: 404;
    payload: Schemas.ProblemDetails;
}>;

export type TasksResultVariables = {
    pathParams: TasksResultPathParams;
    queryParams?: TasksResultQueryParams;
} & ConnectorNextContext['fetcherOptions'];

export const fetchTasksResult = (
    variables: TasksResultVariables,
    signal?: AbortSignal
) =>
    connectorNextFetch<
        undefined,
        TasksResultError,
        undefined,
        {},
        TasksResultQueryParams,
        TasksResultPathParams
    >({
        url: '/api/tasks/{id}/results/{resultPath}',
        method: 'get',
        ...variables,
        signal,
    });

export const useTasksResult = <TData = undefined>(
    variables: TasksResultVariables,
    options?: Omit<
        reactQuery.UseQueryOptions<undefined, TasksResultError, TData>,
        'queryKey' | 'queryFn' | 'initialData'
    >
) => {
    const { fetcherOptions, queryOptions, queryKeyFn } =
        useConnectorNextContext(options);
    return reactQuery.useQuery<undefined, TasksResultError, TData>({
        queryKey: queryKeyFn({
            path: '/api/tasks/{id}/results/{resultPath}',
            operationId: 'tasksResult',
            variables,
        }),
        queryFn: ({ signal }) =>
            fetchTasksResult({ ...fetcherOptions, ...variables }, signal),
        ...options,
        ...queryOptions,
    });
};

export type QueryOperation =
    | {
          path: '/api/access/permissions';
          operationId: 'accessPermissionCatalogue';
          variables: AccessPermissionCatalogueVariables;
      }
    | {
          path: '/api/access/users';
          operationId: 'accessUsers';
          variables: AccessUsersVariables;
      }
    | {
          path: '/api/access/groups';
          operationId: 'accessGroups';
          variables: AccessGroupsVariables;
      }
    | {
          path: '/api/access/groups/{groupId}/members';
          operationId: 'accessGroupMembers';
          variables: AccessGroupMembersVariables;
      }
    | {
          path: '/api/access/record';
          operationId: 'accessChangeRecord';
          variables: AccessChangeRecordVariables;
      }
    | {
          path: '/api/access/directory';
          operationId: 'accessDirectoryAvailable';
          variables: AccessDirectoryAvailableVariables;
      }
    | {
          path: '/api/access/directory/people';
          operationId: 'accessSearchDirectoryPeople';
          variables: AccessSearchDirectoryPeopleVariables;
      }
    | {
          path: '/api/access/directory/groups';
          operationId: 'accessSearchDirectoryGroups';
          variables: AccessSearchDirectoryGroupsVariables;
      }
    | {
          path: '/api/auth/whoami';
          operationId: 'getWhoAmI';
          variables: GetWhoAmIVariables;
      }
    | {
          path: '/api/access/bootstrap';
          operationId: 'bootstrapStatus';
          variables: BootstrapStatusVariables;
      }
    | {
          path: '/api/break-glass/codes';
          operationId: 'breakGlassCodes';
          variables: BreakGlassCodesVariables;
      }
    | {
          path: '/api/break-glass/record';
          operationId: 'breakGlassRecord';
          variables: BreakGlassRecordVariables;
      }
    | {
          path: '/api/break-glass/local-administrator';
          operationId: 'breakGlassLocalAdministrator';
          variables: BreakGlassLocalAdministratorVariables;
      }
    | {
          path: '/api/clinical-tags';
          operationId: 'clinicalListsListTags';
          variables: ClinicalListsListTagsVariables;
      }
    | {
          path: '/api/treatment-sites';
          operationId: 'clinicalListsListSites';
          variables: ClinicalListsListSitesVariables;
      }
    | {
          path: '/api/clinical-people';
          operationId: 'clinicalListsListPeople';
          variables: ClinicalListsListPeopleVariables;
      }
    | {
          path: '/api/configuration';
          operationId: 'configurationRead';
          variables: ConfigurationReadVariables;
      }
    | {
          path: '/api/configuration/authentication';
          operationId: 'configurationReadAuthentication';
          variables: ConfigurationReadAuthenticationVariables;
      }
    | {
          path: '/api/configuration/dicom-peers';
          operationId: 'configurationReadPeers';
          variables: ConfigurationReadPeersVariables;
      }
    | {
          path: '/api/studies/{studyUid}/series/{seriesUid}.zip';
          operationId: 'dataRetrievalGetSeriesZip';
          variables: DataRetrievalGetSeriesZipVariables;
      }
    | {
          path: '/api/studies/{studyUid}/series/{seriesUid}/instances/{sopUid}.dcm';
          operationId: 'dataRetrievalGetInstance';
          variables: DataRetrievalGetInstanceVariables;
      }
    | {
          path: '/api/dicom/targets';
          operationId: 'dicomListTargets';
          variables: DicomListTargetsVariables;
      }
    | {
          path: '/api/dicom/patients';
          operationId: 'dicomQueryPatients';
          variables: DicomQueryPatientsVariables;
      }
    | {
          path: '/api/dicom/query';
          operationId: 'dicomQuery';
          variables: DicomQueryVariables;
      }
    | {
          path: '/api/dicom/retrievals';
          operationId: 'dicomRetrievals';
          variables: DicomRetrievalsVariables;
      }
    | {
          path: '/api/doses/{id}';
          operationId: 'dosesGetById';
          variables: DosesGetByIdVariables;
      }
    | {
          path: '/api/editing-sessions';
          operationId: 'editingSessionsActive';
          variables: EditingSessionsActiveVariables;
      }
    | {
          path: '/api/patients/{patientId}/editing-sessions';
          operationId: 'editingSessionsHistory';
          variables: EditingSessionsHistoryVariables;
      }
    | {
          path: '/api/patients/{patientId}/editors';
          operationId: 'editorsList';
          variables: EditorsListVariables;
      }
    | {
          path: '/api/health';
          operationId: 'getHealth';
          variables: GetHealthVariables;
      }
    | {
          path: '/api/version';
          operationId: 'getVersion';
          variables: GetVersionVariables;
      }
    | {
          path: '/api/images/{id}';
          operationId: 'imagesGetById';
          variables: ImagesGetByIdVariables;
      }
    | {
          path: '/api/auth/modes';
          operationId: 'localSignInModes';
          variables: LocalSignInModesVariables;
      }
    | {
          path: '/api/patients';
          operationId: 'patientsList';
          variables: PatientsListVariables;
      }
    | {
          path: '/api/patients/count';
          operationId: 'patientsCount';
          variables: PatientsCountVariables;
      }
    | {
          path: '/api/patients/{id}';
          operationId: 'patientsGetById';
          variables: PatientsGetByIdVariables;
      }
    | {
          path: '/api/patients/{id}/retrievals';
          operationId: 'patientsGetRetrievals';
          variables: PatientsGetRetrievalsVariables;
      }
    | {
          path: '/api/preferences/me';
          operationId: 'preferencesRead';
          variables: PreferencesReadVariables;
      }
    | {
          path: '/api/registrations/{id}';
          operationId: 'registrationsGetById';
          variables: RegistrationsGetByIdVariables;
      }
    | {
          path: '/api/sessions/{id}';
          operationId: 'sessionsGetById';
          variables: SessionsGetByIdVariables;
      }
    | {
          path: '/api/structure-sets/{id}';
          operationId: 'structureSetsGetById';
          variables: StructureSetsGetByIdVariables;
      }
    | {
          path: '/api/structure-sets/{id}/history';
          operationId: 'structureSetsGetHistory';
          variables: StructureSetsGetHistoryVariables;
      }
    | {
          path: '/api/structure-sets/{id}/model-result';
          operationId: 'structureSetsGetModelResult';
          variables: StructureSetsGetModelResultVariables;
      }
    | {
          path: '/api/tasks';
          operationId: 'tasksList';
          variables: TasksListVariables;
      }
    | {
          path: '/api/tasks/{id}';
          operationId: 'tasksGetById';
          variables: TasksGetByIdVariables;
      }
    | {
          path: '/api/tasks/{id}/results';
          operationId: 'tasksResults';
          variables: TasksResultsVariables;
      }
    | {
          path: '/api/tasks/{id}/results/{resultPath}';
          operationId: 'tasksResult';
          variables: TasksResultVariables;
      };
